function SculpteoOperationUI($el, design, operation, options) {
  this.design = design;
  this.operation = operation;
  this.binded = false;
  this.$el = $el;
  this.is_wizard = false;
  this.step = 0;

  for (k in options) {
    this[k] = options[k];
  }
}

SculpteoOperationUI.from_el = function ($el, design, operation, options) {
  if (!$el.hasClass("SculpteoOperation")) {
    $el = $(".SculpteoOperation", $el);
  }

  if ($el.data("ui")) {
    return $el.data("ui");
  }

  if (!design) {
    return null;
  }

  if (!$el.data("operation") && operation.data) {
    $el.data("operation", operation.data);
  }

  var fieldClasses = $el.attr("class").split(" ");

  for (_klass in fieldClasses) {
    klass = fieldClasses[_klass];

    if (SculpteoOperationUI[klass]) {
      var ui = new SculpteoOperationUI[klass]($el, design, operation, options);

      $el.data("ui", ui);

      return ui;
    }
  }

  var ui = new SculpteoOperationUI($el, design, operation, options);

  $el.data("ui", ui);

  return ui;
};

SculpteoOperationUI.prototype = {
  wizard: function (parent) {
    var _this = this;

    this.is_wizard = true;
    this.parent = parent;
    this.operation = new DesignOperationTemplate(
      this.design,
      this.$el.data("type")["class"],
      this.$el.data("operation")
    );
    this.show_help("help_set_parameters", true, function () {
      _this.show_help("help_click_3dview", true);
    });

    return this;
  },

  select_step: function (index) {
    $(".step", this.$el).hide();
    $(".step" + index, this.$el).show();
    this.step = index;
  },

  next_step: function () {
    this.select_step(this.step + 1);
  },

  previous_step: function () {
    this.select_step(this.step - 1);
  },

  update: function (args) {
    var d = this.$el.data("operation");

    $.extend(d, args);

    return this.operation.modify(args);
  },

  is_modifiable_field: function (field) {
    // Field is modifiable while configuring or if unlocked
    return (
      $(".configurable-field-type-" + field, this.$el).hasClass(
        "configurable-field-state-unlocked"
      ) ||
      $(".configurable-field-type-" + field, this.$el).hasClass(
        "configuration-state-active"
      )
    );
  },

  create_operation: function () {
    var _this = this;

    if (this.validate()) {
      $.when(
        this.operation.create(
          this.$el.data("type")["id"],
          this.$el.data("locked_fields")
        )
      ).then(function () {
        _this.parent.show_success();
      });
    }
  },

  validate: function () {
    return true;
  },

  show_help: function (help, once, callback) {
    if ($("." + help).length == 0) {
      return;
    }

    if (once && $("." + help).data("once")) {
      return;
    }

    var data = eval("(" + $("." + help + " .data").html() + ")");

    $.extend(data, { msg_class: help, callback: callback });
    this.animate_help(data);
    $("." + help).data("once", true);
  },

  animate_help: function (o) {
    var options = o;
    var defaults = {
      msg_class: "",
      target_el_selector: "",
      desc: "",
      hideAfter: false,
      offsetLeft: 0,
      offsetTop: 0,
    };
    var options = $.extend(defaults, o);

    $(".help").hide();
    var target_el = $(o.target_el_selector).first();
    var pos = target_el.offset();

    var help = $(".help." + o.msg_class);

    help
      .show()
      .css({
        opacity: 0,
      })
      .offset({
        top: pos.top + o.offsetTop + 25,
        left: pos.left + o.offsetLeft + target_el.width(),
      })
      .animate({
        opacity: 1,
        top: "-=15",
      })
      .click(function () {
        $(this).hide();
      });

    var t = help.data("timeout");

    if (t) {
      clearTimeout(t);
    }

    if (o.hideAfter) {
      var timeout;

      if (typeof o.hideAfter != "boolean") {
        timeout = o.hideAfter;
      } else {
        timeout = 2000;
      }

      t = setTimeout(function () {
        help.fadeOut({ speed: "slow" });

        if (typeof o.callback != "undefined") {
          o.callback();
        }
      }, timeout);

      help.data("timeout", t);
    }
  },

  bind: function () {
    var _this = this;

    // Auto-bind some fields
    $(".auto-opfield", this.$el).each(function (idx, el) {
      var optype = $(el).data("opfield")["type"],
        opfield = $(el).data("opfield")["name"],
        opvalue = _this.data(opfield);

      switch (optype) {
        case "string":
          $(el)
            .on("keyup", function (event) {
              if (event.keyCode >= 37 && event.keyCode <= 40) {
                // Arrow
                return;
              }

              var args = {};

              args[opfield] = $(this).val();
              _this.update(args);
            })
            .val(opvalue);
          break;
        case "boolean":
          $(el)
            .on("click", function () {
              var args = {};

              args[opfield] = $(this).is(":checked");
              _this.update(args);
            })
            .attr("checked", opvalue);
          break;
        case "slider":
          var slider_options = $(el).data("opfield")["options"];

          slider_options["controlled_param"] = opfield;
          slider_options["value"] = _this.data(opfield);
          _this.slider($(el), slider_options);

        case "color":
          _this.color_wheel($(el), {
            controlled_param: opfield,
            value: {
              r: _this.data(opfield + "_r"),
              g: _this.data(opfield + "_g"),
              b: _this.data(opfield + "_b"),
            },
          });
        default:
          break;
      }
    });

    // Configuration mode
    $(".lock-operation", _this.$el).on("click", function (evt) {
      var target = this.href;

      evt.preventDefault();

      var locked_fields = _this.$el.data("locked_fields");

      if (typeof locked_fields != "object") {
        locked_fields = {};
      }

      var $configurable_field = $(this).closest(".configurable-field");
      var field = $configurable_field
        .attr("class")
        .match(/configurable-field-type-\w+/g)[0]
        .match(/\w+/g)[3];

      target += "&uuid=" + _this.design.model_uuid;

      if ($(this).is(".ui-icon-locked")) {
        locked_fields[field] = false;
        target += "&locked=0";

        // Lock all fields of the same class
        $(".configurable-field-type-" + field + " .lock-operation", _this.$el)
          .removeClass("ui-icon-locked")
          .addClass("ui-icon-unlocked")
          .attr("title", gettext("Lock parameter"));
        $(".configurable-field-type-" + field, _this.$el)
          .removeClass("configurable-field-state-locked")
          .addClass("configurable-field-state-unlocked");
      } else {
        locked_fields[field] = true;
        target += "&locked=1";

        // Unlock all fields of the same class
        $(".configurable-field-type-" + field + " .lock-operation", _this.$el)
          .removeClass("ui-icon-unlocked")
          .addClass("ui-icon-locked")
          .attr("title", gettext("Unlock parameter"));
        $(".configurable-field-type-" + field, _this.$el)
          .removeClass("configurable-field-state-unlocked")
          .addClass("configurable-field-state-locked");
      }

      if (target[0] != "#") {
        $.get(target);
      }

      log("locked fields: ");
      log(locked_fields);
      _this.$el.data("locked_fields", locked_fields);

      return false;
    });

    $(".ui-state-active", _this.$el).hover(function (evt) {
      $(this).toggleClass("ui-state-highlight");
    });

    $(".toggle-translation-description", _this.$el).on("click", function () {
      $(".translation-description", _this.$el).toggle();
      $(".translated-description", _this.$el).focus();

      if ($(".translated-description", _this.$el).is(":hidden")) {
        $(".translated-description", _this.$el).val(
          $(".main-description", _this.$el).val()
        );
      }

      return false;
    });

    if (
      $(".main-description", _this.$el).val() !=
      $(".translated-description", _this.$el).val()
    ) {
      $(".translation-description", _this.$el).show();
    }

    $(".main-description, .translated-description", _this.$el).on(
      "keyup",
      function () {
        _this.update({
          description_fr: $("[name=description_fr]", _this.$el).val(),
          description_de: $("[name=description_de]", _this.$el).val(),
          description_en: $("[name=description_en]", _this.$el).val(),
        });
      }
    );

    $(".main-description", _this.$el).on("keyup", function () {
      // Copy description from textarea to description field for preview
      $(".operation-description", _this.$el).html($(this).val());
    });

    $(".remove-operation", this.$el).on("click", function () {
      $.when(_this.operation.remove()).then(function () {
        TabItemUI.hide();
        _this.design.reload_operations();
      });

      return false;
    });

    var getParameter = function (el) {
      return $(el).closest(".SculpteoParameter");
    };

    var getControlParams = function (name, value, data) {
      for (k in data.__params__) {
        var d = data.__params__[k];

        if (d.controls[name] == value) {
          return d;
        }
      }

      return {};
    };

    var parameters_class = {
      designoperationsliderparameter: {
        init: function ($param) {
          var id = $param.data("parameter").id;
          var slider_options = $(".slider-control", $param).data("options");

          slider_options["controlled_param"] = id;
          slider_options["step"] =
            (slider_options["max"] - slider_options["min"]) / 100;
          _this.slider($(".slider-control", $param), slider_options);
        },
      },

      designoperationtextparameter: {
        init: function ($param) {
          var id = $param.data("parameter").id,
            $input = $("input", $param);

          $input.on(
            "keyup",
            parameters_class.designoperationtextparameter.text_input
          );
          $input.on(
            "blur",
            parameters_class.designoperationtextparameter.text_blur
          );
          $input.attr("name", id).val($input.data("options").value);
        },

        text_input: function (event) {
          if (event.keyCode >= 37 && event.keyCode <= 40) {
            // Arrow
            return;
          }

          if (event.keyCode == 13) {
            // Enter
            var data = {};

            data[this.name] = $(this).val();
            _this.update(data);
          }
        },

        text_blur: function (event) {
          var data = {};

          data[this.name] = $(this).val();
          _this.update(data);
        },
      },

      designoperationbubbleparameter: {
        init: function ($param) {
          var id = $param.data("parameter").id;
          var bubble = new Object();

          bubble.is_done = false;
          // We don't care if this fails, it's only used for the phone cases
          require_fail(["kinetic-v4.5.3.min"], function (Kinetic) {
            bubble = new BubbleCanvas($(".bubble-canvas", $param)[0], Kinetic);
            bubble.setBackground(
              $(".bubble-canvas", $param).data("background")
            );
            bubble.load();
          });

          $(".wizard").wizard("onShow", {
            el: _this.$el,
            cb: function () {
              if (!bubble.is_done) {
                $(".wizard").wizard("disableNext");
              }
            },
          });

          $(".wizard").wizard("disableNext");
          $(".btn-bubble", $param).on("click", function () {
            $(".wizard").wizard("enableNext");
            var args = {};

            args[id] = bubble.done();
            _this.update(args);

            return false;
          });
        },
      },

      designoperationplacedimageparameter: {
        init: function ($param) {
          var id = $param.data("parameter").id;
          var pi = new Object();

          // We don't care if this fails, it's only used for the phone cases
          require_fail(["kinetic-v4.5.3.min"], function (Kinetic) {
            pi = new PlaceImage(
              $(".placeimage-canvas", $param)[0],
              {},
              Kinetic
            );
            var $canvasContainer = $(".placeimage-canvas", $param);

            pi = new PlaceImage($canvasContainer[0], {}, Kinetic);
            var parentWidth = $canvasContainer.parent().width(),
              currentWidth = $canvasContainer.width();

            if (parentWidth < currentWidth) {
              pi.width = pi.height = parentWidth;
              $canvasContainer.css({ width: parentWidth });
            }

            $(".texture-place", $param).data("pi", pi);
          });

          _this.media_upload(
            $(".picker-add", $param),
            $param,
            "image",
            undefined,
            undefined,
            true
          );
          $(".gallery-texture-pick", $param).on(
            "click",
            "img",
            parameters_class.designoperationplacedimageparameter.select_texture
          );
          $(".wizard").wizard("onShow", {
            el: _this.$el,
            cb: function () {
              if (!pi.is_done) {
                $(".wizard").wizard("disableNext");
              }
            },
          });

          if (!pi.is_done) {
            $(".wizard").wizard("disableNext");
          }

          $(".btn-try", $param).on("click", function () {
            $(".wizard").wizard("enableNext");
            $(".other-params", $param).show();
            var pos = pi.done();
            var args = {};

            args[id] = $(".gallery-texture-pick img.selected", $param).data(
              "id"
            );
            args[id + ".crop_x"] = pos.crop_x;
            args[id + ".crop_y"] = pos.crop_y;
            args[id + ".crop_w"] = pos.crop_width;
            args[id + ".crop_h"] = pos.crop_height;
            (args["cornerx1"] = pos.x),
              (args["cornery1"] = pos.y),
              (args["cornerx2"] = pos.end_x),
              (args["cornery2"] = pos.end_y),
              _this.update(args);

            return false;
          });
        },

        select_texture: function (event) {
          var $param = getParameter(this),
            id = $param.attr("id");

          $(".gallery-texture-pick img", $param).removeClass("selected");
          $(this).addClass("selected");
          $("[href=#accordion-" + id + "-two]").click();
          $(".message-select-image").hide();
          $(".placeimage-canvas, .btn-try").show();
          var backgroundImage = $(".placeimage-canvas", $param).data(
            "background"
          );

          $(".texture-place", $param)
            .data("pi")
            .loadBackground(backgroundImage)
            .loadImage($(this).data("src"));

          return false;
        },
      },

      designoperationprintedbackgroundparameter: {
        init: function ($param) {
          var id = $param.data("parameter").id,
            pi = new Object();

          // We don't care if this fails, it's only used for the phone cases
          require_fail(["kinetic-v4.5.3.min"], function (Kinetic) {
            pi = new PlaceImage(
              $(".placeimage-canvas", $param)[0],
              { with_bg_color: true, transparent_template: true },
              Kinetic
            );
            $(".texture-place", $param).data("pi", pi);
            $(".placeimage-canvas", $param).data("pi", pi);
            pi.add_listener("update_region", function (pos) {
              $(".other-params", $param).show();
              var args = {};

              args[id] = $("[data-selector=texture].selected", $param).data(
                "id"
              );
              args[id + ".crop_x"] = pos.crop_x;
              args[id + ".crop_y"] = pos.crop_y;
              args[id + ".crop_w"] = pos.crop_width;
              args[id + ".crop_h"] = pos.crop_height;
              args[id + ".size_corner_x1"] = pos.x;
              args[id + ".size_corner_y1"] = pos.y;
              args[id + ".size_corner_x2"] = pos.end_x;
              args[id + ".size_corner_y2"] = pos.end_y;
              args[id + ".size_bg_r"] = pos.bg_r;
              args[id + ".size_bg_g"] = pos.bg_g;
              args[id + ".size_bg_b"] = pos.bg_b;
              _this.update(args);

              return false;
            });
          });

          _this.media_upload(
            $("[data-selector=texture-add]", $param),
            $param,
            "image",
            undefined,
            undefined,
            true
          );

          $("a.white_plastic_printed").click();
          $param.on(
            "click",
            "[data-selector=texture]",
            parameters_class.designoperationprintedbackgroundparameter
              .select_texture
          );
        },

        select_texture: function (event) {
          var $param = getParameter(this),
            id = $param.attr("id");
          var old_id = $("[data-selector=texture].selected", $param).data("id");

          $("[data-selector=texture]", $param).removeClass("selected");
          $(this).addClass("selected");

          if ($(this).data("id")) {
            // Move canvas if necessary
            $("a.white_plastic_printed").click();
            var canvasContainer = $(
                ".placeimage-canvas-container",
                $param
              ).closest(".texture-container"),
              thumbContainer = $(this).closest(".texture-container");

            if (canvasContainer[0] != thumbContainer[0]) {
              $(".placeimage-canvas-container", $param)
                .detach()
                .insertAfter($("h4", thumbContainer));
            }

            $(".placeimage-canvas-container").slideDown();
            var pi = $(".placeimage-canvas", $param).data("pi");
            var $canvasContainer = $(".placeimage-canvas", $param);
            var parentWidth = $canvasContainer.parent().width(),
              currentWidth = $canvasContainer.width();

            if (parentWidth < currentWidth) {
              pi.width = pi.height = parentWidth;
              $canvasContainer.css({ width: parentWidth });
            }

            // Args[id] = $(this).data("id");
            // _this.update(args);
            var backgroundImage = $(".placeimage-canvas", $param).data(
              "background"
            );
            var cb = old_id
              ? function () {
                  parameters_class.designoperationprintedbackgroundparameter.checkDimensions(
                    $param,
                    thumbContainer,
                    pi.getImageDimensions()
                  );
                }
              : function () {
                  var pos = pi.done();
                  var args = {};

                  args[id] = $("[data-selector=texture].selected", $param).data(
                    "id"
                  );
                  args[id + ".crop_x"] = pos.crop_x;
                  args[id + ".crop_y"] = pos.crop_y;
                  args[id + ".crop_w"] = pos.crop_width;
                  args[id + ".crop_h"] = pos.crop_height;
                  args[id + ".size_corner_x1"] = pos.x;
                  args[id + ".size_corner_y1"] = pos.y;
                  args[id + ".size_corner_x2"] = pos.end_x;
                  args[id + ".size_corner_y2"] = pos.end_y;
                  args[id + ".size_bg_r"] = pos.bg_r;
                  args[id + ".size_bg_g"] = pos.bg_g;
                  args[id + ".size_bg_b"] = pos.bg_b;
                  $.when(_this.update(args)).then(function () {
                    _this.design.order.refreshAmount();
                  });

                  parameters_class.designoperationprintedbackgroundparameter.checkDimensions(
                    $param,
                    thumbContainer,
                    pi.getImageDimensions()
                  );
                };

            pi.loadBackground(backgroundImage).loadImage(
              $(this).data("src"),
              cb
            );
          } else {
            var args = {};

            args[id] = "";
            $(".placeimage-canvas-container").slideUp();
            $.when(_this.update(args)).then(function () {
              if (old_id) {
                _this.design.order.refreshAmount();
              }
            });
          }

          return false;
        },

        checkDimensions: function ($param, thumbContainer, dimensions) {
          var valid = dimensions.width > 800 && dimensions.height > 600;
          var myContainer = $(".alert-resolution", $param).closest(
            ".texture-container"
          );

          if (myContainer[0] != thumbContainer[0]) {
            $(".alert-resolution", $param)
              .detach()
              .insertAfter($("h4", thumbContainer));
          }

          var nextbutton = $("#order-submit").closest(".btn-group");

          if (valid) {
            $(".alert-resolution", $param).fadeOut();
            nextbutton.show();
          } else {
            $(".alert-resolution", $param).fadeIn();
            nextbutton.hide();
          }
        },
      },

      designoperationaudioparameter: {
        init: function ($param) {
          var $scrollPick = $(
              ".audio-selection",
              $param
            ).SculpteoHorizontalPicker(),
            data = _this.$el.data("operation"),
            id = $param.data("parameter").id;

          _this.media_upload($(".picker-add", $param), $param, "audio");
          _this.media_upload(
            $(".audio-record", $param),
            $param,
            "audio",
            "record"
          );
          var params = getControlParams("value", id, data);

          if (data[id]) {
            $(".selected-audio", $param).show();
          } else {
            $(".audio-selection", $param).show();
          }

          $(".change-audio", $param).click(
            parameters_class.designoperationaudioparameter.show_selection
          );
          $(".audio-selection", $param).delegate(
            ".picker-scroll-content-item:not(.picker-add) a.audioSelect",
            "click",
            parameters_class.designoperationaudioparameter.select
          );
          // We don't care about audio parameter in the UI
          require_fail(["jquery.ubaplayer-1.0.0.src"], function () {
            $("#ubaPlayer").ubaPlayer({
              audioContainer: $param,
              codecs: [
                { name: "WAV", codec: "audio/wav" },
                { name: "MP3", codec: "audio/mpeg" },
                { name: "OGG", codec: "audio/ogg" },
              ],
              swfobjectPath: STATIC_URL + "js/ubaplayer/swfobject.js",
              flashAudioPlayerPath: STATIC_URL + "js/ubaplayer/player.swf",
              extension: "",
            });
          });
        },

        show_selection: function (event) {
          var $param = getParameter(this);

          $(".audio-selection", $param).show();
          $(".selected-audio", $param).hide();

          return false;
        },

        select: function (event) {
          var $param = getParameter(this);
          var $div = $(this).parent();
          var id = $param.attr("id");
          var uuid = extractIdFromClass($(".audioSelect", $div), "audio-");
          var url = $(".audioButton", $div).attr("href");
          var name = $(".audioButton", $div).text();

          args = {};
          args[id] = uuid;
          _this.update(args);
          $(".audio-selection", $param).hide();
          $(".selected-audio", $param).show();
          $(".selected-audio", $param).show();
          $(".selected-audio .audioButton", $param)
            .attr("href", url)
            .text(name);

          return false;
        },
      },

      designoperationtextureparameter: {
        init: function ($param) {
          var $scrollPick = $(
              ".texture-selection",
              $param
            ).SculpteoHorizontalPicker(),
            data = _this.$el.data("operation"),
            id = $param.data("parameter").id;

          _this.media_upload($(".picker-add", $param), $param, "image");
          var params = getControlParams("value", id, data);

          if (data[id]) {
            $(".selected-texture", $param).show();
            parameters_class.designoperationtextureparameter.crop_texture(
              $(".selected-texture > .image-to-crop", $param),
              params
            );
          } else {
            $(".texture-selection", $param).show();
          }

          $(".change-texture", $param).click(
            parameters_class.designoperationtextureparameter.show_selection
          );
          $(".select-control input[type=radio]", $param).change(
            parameters_class.designoperationtextureparameter.change
          );
          $("[data-s-action=selecttexture]", $param).on(
            "click",
            parameters_class.designoperationtextureparameter.change
          );
          $(".texture-selection", $param).on(
            "click",
            ".picker-scroll-content-item:not(.picker-add)",
            parameters_class.designoperationtextureparameter.select_texture
          );
        },

        show_selection: function (event) {
          var $param = getParameter(this);

          $(".texture-selection, .texture-selection-bs", $param).show();
          $(".selected-texture", $param).hide();

          return false;
        },

        change: function () {
          var $param = getParameter(this);

          args = {};
          var id = $param.attr("id");

          if ($(this).data("sId")) {
            args[id] = $(this).data("sId");
          } else {
            args[id] = $(this).val();
          }

          _this.update(args);
        },

        select_texture: function (event) {
          var $param = getParameter(this),
            $img = $("img", this),
            uuid = $img.data("id"),
            id = $param.attr("id");

          args = {};
          args[id] = uuid;
          args[id + ".crop_x"] = 0.0;
          args[id + ".crop_y"] = 0.0;
          args[id + ".crop_w"] = 1.0;
          args[id + ".crop_h"] = 1.0;
          _this.update(args);
          $(".texture-selection", $param).hide();
          $(".selected-texture", $param).show();
          parameters_class.designoperationtextureparameter.crop_texture(
            $(".selected-texture > .image-to-crop", $param),
            { urls: { value: $img.attr("src") } }
          );
        },

        crop_texture: function ($img, params, cb) {
          var $param = getParameter($img);
          var initial_crop = null;

          if ($img.data("jcrop_api")) {
            var jcrop_api = $img.data("jcrop_api");

            jcrop_api.destroy();
            initial_crop = {
              x: 0,
              y: 0,
              w: 1,
              h: 1,
            };
            $img.data("jcrop_api", "");
          } else {
            if (params.crop) {
              initial_crop = params.crop.value;
            }
          }

          $img.attr("src", params.urls.value).Jcrop(
            {
              onSelect: function setCoords(c) {
                args = {};
                var w = this.getWidgetSize()[0],
                  h = this.getWidgetSize()[1];
                var id = $param.attr("id");

                args[id + ".crop_x"] = c.x / w;
                args[id + ".crop_y"] = c.y / h;
                args[id + ".crop_w"] = c.w / w;
                args[id + ".crop_h"] = c.h / h;
                _this.update(args);
              },
            },
            function () {
              var jcrop_api = this;

              $img.data("jcrop_api", jcrop_api);
              jcrop_api.setSelect([
                initial_crop.x * this.getWidgetSize()[0],
                initial_crop.y * this.getWidgetSize()[1],
                (initial_crop.x + initial_crop.w) * this.getWidgetSize()[0],
                (initial_crop.y + initial_crop.h) * this.getWidgetSize()[1],
              ]);
            }
          );
        },
      },

      cardboxlaposte: {
        init: function ($param) {
          var data = _this.$el.data("operation"),
            id = $param.data("parameter").id;
          var params = getControlParams("value", id, data);

          $(".texture-selection", $param).on(
            "click",
            ".picker-scroll-content-item:not(.picker-add)",
            parameters_class.cardboxlaposte.select_texture
          );
          $(".texture-gallery", $param).addClass("permanent");
        },

        select_texture: function (event) {
          var $param = getParameter(this),
            $img = $("img", this),
            uuid = $img.data("id"),
            id = $param.attr("id");

          $(".picker-scroll-content-item", $param).removeClass(
            "texture-active"
          );
          $(this).addClass("texture-active");
          args = {};
          args[id] = uuid;
          args[id + ".crop_x"] = 0.0;
          args[id + ".crop_y"] = 0.0;
          args[id + ".crop_w"] = 1.0;
          args[id + ".crop_h"] = 1.0;
          _this.update(args);
        },
      },

      designoperationlogoparameter: {
        init: function ($param) {
          var $scrollPick = $(
              ".texture-selection",
              $param
            ).SculpteoHorizontalPicker(),
            id = $param.data("parameter").id,
            data = _this.$el.data("operation");

          _this.media_upload($(".picker-add", $param), $param, "image");
          var id = $param.attr("id");
          var param_data = getControlParams("value", id, data)["vectorize"][
            "value"
          ];

          if (data[id]) {
            $(".selected-texture", $param).show();
            parameters_class.designoperationlogoparameter.update_vectorized(
              $param,
              parameters_class.designoperationlogoparameter.get_vectorization_parameters(
                $param,
                true
              )
            );
          } else {
            $(".texture-selection", $param).show();
          }

          $(".delete-texture", $param).click(
            parameters_class.designoperationlogoparameter.show_selection_empty
          );
          $(".change-texture", $param).on(
            "click",
            parameters_class.designoperationlogoparameter.show_selection
          );
          $(".texture-selection", $param).on(
            "click",
            ".picker-scroll-content-item:not(.picker-add)",
            parameters_class.designoperationlogoparameter.select_texture
          );
          _this.slider($(".slider-control.contrast-slider", $param), {
            min: 0,
            max: 100,
            step: 1,
            value: param_data["contrast_threshold"],
            reset_value: param_data["contrast_threshold"],
            controlled_param: id + ".contrast_threshold",
            disabled: param_data["contrast_threshold_automatic"],
            cb: function (opts) {
              parameters_class.designoperationlogoparameter.update_vectorized(
                $param,
                parameters_class.designoperationlogoparameter.get_vectorization_parameters(
                  $param,
                  false
                )
              );
            },
          });
          _this.slider($(".slider-control.detail-slider", $param), {
            min: 0,
            max: 200,
            step: 1,
            value: param_data["detail_threshold"],
            reset_value: param_data["detail_threshold"],
            controlled_param: id + ".detail_threshold",
            disabled: param_data["detail_threshold_automatic"],
            cb: function (opts) {
              parameters_class.designoperationlogoparameter.update_vectorized(
                $param,
                parameters_class.designoperationlogoparameter.get_vectorization_parameters(
                  $param,
                  false
                )
              );
            },
          });

          if (param_data["contrast_threshold_automatic"]) {
            $(".contrast-slider .the-slider", $param).slider("disable");
          }

          if (param_data["detail_threshold_automatic"]) {
            $(".detail-slider .the-slider", $param).slider("disable");
          }

          $(".contrast-auto.contrast-auto-off", $param)
            .toggle(!param_data["contrast_threshold_automatic"])
            .click(function () {
              $(".contrast-auto", $param).toggle();
              var opts = {};

              opts[id + ".contrast_threshold_automatic"] = true;
              _this.update(opts);
              $(".contrast-slider .the-slider", $param).slider("disable");
              parameters_class.designoperationlogoparameter.update_vectorized(
                $param,
                parameters_class.designoperationlogoparameter.get_vectorization_parameters(
                  $param,
                  false
                )
              );

              return false;
            });

          $(".contrast-auto.contrast-auto-on", $param)
            .toggle(param_data["contrast_threshold_automatic"])
            .click(function () {
              $(".contrast-auto", $param).toggle();
              var opts = {};

              opts[id + ".contrast_threshold_automatic"] = false;
              _this.update(opts);
              $(".contrast-slider .the-slider", $param).slider("enable");
              parameters_class.designoperationlogoparameter.update_vectorized(
                $param,
                parameters_class.designoperationlogoparameter.get_vectorization_parameters(
                  $param,
                  false
                )
              );

              return false;
            });

          $(".detail-auto.detail-auto-off", $param)
            .toggle(!param_data["detail_threshold_automatic"])
            .click(function () {
              $(".detail-auto", $param).toggle();
              var opts = {};

              opts[id + ".detail_threshold_automatic"] = true;
              _this.update(opts);
              $(".detail-slider .the-slider", $param).slider("disable");
              parameters_class.designoperationlogoparameter.update_vectorized(
                $param,
                parameters_class.designoperationlogoparameter.get_vectorization_parameters(
                  $param,
                  false
                )
              );

              return false;
            });

          $(".detail-auto.detail-auto-on", $param)
            .toggle(param_data["detail_threshold_automatic"])
            .click(function () {
              $(".detail-auto", $param).toggle();
              var opts = {};

              opts[id + ".detail_threshold_automatic"] = true;
              _this.update(opts);
              $(".detail-slider .the-slider", $param).slider("enable");
              parameters_class.designoperationlogoparameter.update_vectorized(
                $param,
                parameters_class.designoperationlogoparameter.get_vectorization_parameters(
                  $param,
                  false
                )
              );

              return false;
            });
        },

        get_vectorization_parameters: function ($_param, from_data) {
          var id = $_param.attr("id"),
            data = _this.$el.data("operation");
          var param_data = getControlParams("value", id, data);
          var v = param_data["vectorize"]["value"];

          if (from_data) {
            return {
              contrast_threshold: v["contrast_threshold"],
              contrast_threshold_automatic: v["contrast_threshold_automatic"],
              detail_threshold: v["detail_threshold"],
              detail_threshold_automatic: v["detail_threshold_automatic"],
              o_logo: data[id],
              mask_id: v["mask_id"],
              methodid: v["methodid"],
            };
          } else {
            // Get values from widgets
            return {
              contrast_threshold: $(
                ".contrast-slider .the-slider",
                $_param
              ).slider("value"),
              contrast_threshold_automatic: $(
                ".contrast-auto.contrast-auto-on",
                $_param
              ).is(":visible"),
              detail_threshold: $(".detail-slider .the-slider", $_param).slider(
                "value"
              ),
              detail_threshold_automatic: $(
                ".detail-auto.detail-auto-on",
                $_param
              ).is(":visible"),
              o_logo: data[id],
              mask_id: v["mask_id"],
              methodid: v["methodid"],
            };
          }
        },

        show_selection_empty: function (event) {
          var $param = getParameter(this);
          var id = $param.attr("id");
          var uuid = "TN6hvQYT6C5A0GO0";

          args = {};
          args[id] = uuid;
          _this.update(args);
          $(".texture-selection", $param).hide();
          $(".selected-texture", $param).show();
          parameters_class.designoperationlogoparameter.update_vectorized(
            $param,
            parameters_class.designoperationlogoparameter.get_vectorization_parameters(
              $param,
              false
            )
          );
        },

        show_selection: function (event) {
          var $param = getParameter(this);

          $(".texture-selection", $param).show();
          $(".selected-texture", $param).hide();

          return false;
        },

        select_texture: function (event) {
          var $param = getParameter(this);
          var $img = $("img", this);
          var id = $param.attr("id");

          console.log(id);
          var uuid = $img.data("id");

          args = {};
          console.log(uuid);
          args[id] = uuid;
          _this.update(args);
          $(".texture-selection", $param).hide();
          $(".selected-texture", $param).show();
          parameters_class.designoperationlogoparameter.update_vectorized(
            $param,
            parameters_class.designoperationlogoparameter.get_vectorization_parameters(
              $param,
              false
            )
          );
        },

        update_vectorized: function ($_param, opts) {
          $.getJSON(URLS["x_design_vectorized_image"], opts, function (d) {
            $(".vectorized-image", $_param).attr("src", d.url);
          });
        },
      },

      skinparameter: {
        init: function ($param) {
          var $scrollPick = $(
              ".texture-selection",
              $param
            ).SculpteoHorizontalPicker(),
            id = $param.data("parameter").id,
            data = _this.$el.data("operation");

          _this.media_upload($(".picker-add", $param), $param, "image");
          var id = $param.attr("id");

          $(".change-texture", $param).click(function () {
            $(".skin-picture", $param).show();
            $(".skin-crop", $param).hide();
          });

          $(".gallery-texture-pick", $param).on(
            "click",
            "img",
            parameters_class.skinparameter.select_texture
          );
          $(".wizard").wizard("onShow", {
            el: _this.$el,
            cb: function () {
              if (!$(".gallery-texture-pick img.selected", $param).data("id")) {
                $(".wizard").wizard("disableNext");
              }
            },
          });

          $(".wizard").wizard("disableNext");
          $(".skin-crop-done", $param).on("click", function () {
            $(".skin-result", $param).show();
            var args = $.extend(
              {},
              $(".skin-crop-canvas", $param).data("crop").crop_information
            );

            args["uuid"] = $(".gallery-texture-pick img.selected", $param).data(
              "id"
            );
            $.post(URLS["x_create_skin_mask"], args, function (data) {
              $(".skin-result img", $param).attr("src", data.mask.url);
              var id = $param.attr("id");
              var opts = {};

              opts[id] = data.mask.id;
              _this.update(opts);
              $(".wizard").wizard("enableNext");
            });

            return false;
          });

          parameters_class.camera_input($param);
        },

        select_texture: function (event) {
          var $param = getParameter(this);
          var $img = $(this);

          $(".gallery-texture-pick img", $param).removeClass("selected");
          $img.addClass("selected");
          $(".skin-crop", $param).show();
          $(".skin-picture", $param).hide();
          var ci = $(".skin-crop-canvas", $param).data("crop");

          if (ci) {
            ci.clear();
          } else {
            ci = new CropImage($(".skin-crop-canvas", $param)[0]);
            $(".skin-crop-canvas", $param).data("crop", ci);
          }

          ci.load($img.data("src"), function () {
            $(".crop-loading", $param).hide();
          });
        },
      },

      camera_input: function ($param) {
        $(".camera-trigger", $param)
          .off("click")
          .on("click", function () {
            $(".camera-snapshot", $param).hide();
            webcam.capture(3);

            return false;
          });

        $(".camera-ok", $param)
          .off("click")
          .on("click", function () {
            var imgData = $(".camera-snapshot canvas", $param)
              .get(0)
              .toDataURL("image/png")
              .substr(22);

            $(".camera-upload", $param).show();
            $.when(
              _this.media_upload(
                $(".picker-add", $param),
                $param,
                "image",
                "",
                imgData
              )
            ).then(function () {
              $(".camera-upload", $param).hide();
              $(".camera-container", $param).hide();
              $(".camera-output", $param).empty();
            });

            return false;
          });

        $(".take-picture", $param).on("click", function () {
          $(".camera-container", $param).toggle();

          if ($(".camera-container", $param).is(":visible")) {
            var $canvas = $(".camera-snapshot canvas", $param),
              ctx = $canvas.get(0).getContext("2d"),
              pos = 0,
              width = 480,
              height = 360,
              img = ctx.getImageData(0, 0, width, height);

            if ($("#flash").length == 0) {
              $("body").append(
                $("<div></div>", { id: "flash" })
                  .css({
                    position: "fixed",
                    top: "0px",
                    left: "0px",
                    "text-align": "center",
                    "font-size": "60px",
                    color: "white",
                    "padding-top": "200px",
                    "z-index": "5000",
                    width: "100%",
                    height: "100%",
                    "background-color": "#c00",
                    display: "none",
                  })
                  .text("Cheese!")
              );
            }

            ctx.clearRect(0, 0, width, height);
            $(".camera-output", $param).empty();
            $(".camera-snapshot", $param).hide();
            $(".camera-output", $param).webcam({
              width: width,
              height: height,
              mode: "callback",
              swffile: STATIC_URL + "js/webcam/jQuery-webcam/jscam.swf",
              onTick: function (remain) {
                if (remain == 0) {
                  $(".camera-ticker", $param)
                    .show()
                    .text("Cheese!")
                    .delay(500)
                    .fadeOut();
                  $("#flash").fadeIn(200);
                } else {
                  $(".camera-ticker", $param)
                    .show()
                    .text(remain + "s");
                }
              },

              onSave: function (data) {
                var col = data.split(";");

                for (var i = 0; i < width; i++) {
                  var tmp = parseInt(col[i]);

                  img.data[pos + 0] = (tmp >> 16) & 0xff;
                  img.data[pos + 1] = (tmp >> 8) & 0xff;
                  img.data[pos + 2] = tmp & 0xff;
                  img.data[pos + 3] = 0xff;
                  pos += 4;
                }

                if (pos >= 4 * width * height) {
                  ctx.putImageData(img, 0, 0);
                  pos = 0;
                }
              },

              onCapture: function () {
                $(".camera-snapshot", $param).show();
                webcam.save();
                $("#flash").fadeOut(200);
              },

              onLoad: function () {
                var cams = webcam.getCameraList();
              },

              debug: function (type, string) {
                if (type == "error" && string == "No camera was detected.") {
                  $(".no-camera", $param).show();
                  $(".camera-trigger").hide();
                }
              },
            });
          }

          return false;
        });
      },

      designoperationfaceprofileparametercanvas: {
        init: function ($param) {
          var $scrollPick = $(
              ".texture-selection",
              $param
            ).SculpteoHorizontalPicker(),
            id = $param.data("parameter").id,
            data = _this.$el.data("operation"),
            pi = new Object();

          // We don't care if this fails, it's only used for the phone cases
          require_fail(["kinetic-v4.5.3.min"], function (Kinetic) {
            var $canvasContainer = $(".placeimage-canvas", $param);

            pi = new PlaceImage($canvasContainer[0], {}, Kinetic);
            var parentWidth = $canvasContainer.parent().width(),
              currentWidth = $canvasContainer.width();

            if (parentWidth < currentWidth) {
              pi.width = pi.height = parentWidth;
              $canvasContainer.css({ width: parentWidth });
            }

            // Step 2
            $(".orientation.orientation-left", $param).click(function () {
              $("[href=#accordion-" + id + "-three]").click();
              $(".orientation", $param).removeClass("selected");
              $(this).addClass("selected");
              pi.loadBackground(
                STATIC_URL + "images/designer-product/profile-left-place.png"
              ).loadImage(
                $(".selected-texture .faceprofile-image", $param).data("src")
              );

              return false;
            });

            $(".orientation.orientation-right", $param).click(function () {
              $("[href=#accordion-" + id + "-three]").click();
              $(".orientation", $param).removeClass("selected");
              $(this).addClass("selected");
              pi.loadBackground(
                STATIC_URL + "images/designer-product/profile-right-place.png"
              ).loadImage(
                $(".selected-texture .faceprofile-image", $param).data("src")
              );

              // Parameters_class.designoperationfaceprofileparametercanvas.place_profile($param);
              return false;
            });
          });

          _this.media_upload(
            $(".picker-add", $param),
            $param,
            "image",
            undefined,
            undefined,
            true
          );

          // Step 1
          $(".gallery-texture-pick", $param).on(
            "click",
            "img",
            parameters_class.designoperationfaceprofileparametercanvas
              .select_texture
          );

          // Step 3
          $(".profile-place-done", $param).on("click", function () {
            $("[href=#accordion-" + id + "-four]").click();
            parameters_class.designoperationfaceprofileparametercanvas.update_faceprofile(
              $param,
              parameters_class.designoperationfaceprofileparametercanvas.get_detection_parameters(
                $param,
                pi
              )
            );

            return false;
          });

          var hideNext =
            (!$(".faceprofile-image", $param).data("fp") ||
              !$(".faceprofile-image", $param).data("fp").is_done) &&
            !$(".same-profile", _this.$el).is(":checked");

          $(".wizard").wizard("onShow", {
            el: _this.$el,
            cb: function () {
              if (hideNext) {
                $(".wizard").wizard("disableNext");
              }
            },
          });

          if (hideNext) {
            $(".wizard").wizard("disableNext");
          }

          $(".profile-done", $param).on("click", function () {
            var d = $(".faceprofile-image", $param).data("fp").done();
            var id = $param.attr("id");
            var opts = {};

            // $(".offset-control", $param).show();
            opts[id + ".profile"] = "[ " + d.profile.toString() + " ]";
            opts[id + ".aspectratio"] = d.aspectratio;

            if ($(".same-profile").is(":checked")) {
              var paramid = $(".same-profile").data("paramid");

              opts[paramid + ".profile"] = opts[id + ".profile"];
              opts[paramid + ".aspectratio"] = opts[id + ".aspectratio"];
            }

            _this.update(opts);
            $(".wizard").wizard("enableNext");

            return false;
          });

          $(".same-profile", $param).on("click", function () {
            $(".texture-control", $param).toggle();

            if ($(this).is(":checked")) {
              var opts = {};

              opts[id + ".profile"] = "";
              _this.update(opts);
              $(".wizard").wizard("enableNext");
            }
          });

          parameters_class.camera_input($param);
        },

        update_faceprofile: function ($_param, opts) {
          if (opts.uuid == null) {
            return;
          }

          $(".faceprofile-image", $_param).attr("src", LOADER_URL);
          $(".computing", $_param).show();
          $.getJSON(URLS["x_design_faceprofile_image"], opts, function (d) {
            $(".computing", $_param).hide();

            if (d.profile.length <= 1) {
              $(".faceprofile-image, .profile-done", $_param).hide();
              $(".faceprofile-not-detected", $_param).show();

              return;
            } else {
              $(".faceprofile-image, .profile-done", $_param).show();
              $(".faceprofile-not-detected", $_param).hide();
            }

            var fp = $(".faceprofile-image", $_param).data("fp");

            if (!fp) {
              // We don't care if this fails, it's only used for the phone cases
              require_fail(["kinetic-v4.5.3.min"], function (Kinetic) {
                fp = new FaceProfile(
                  $(".faceprofile-image", $_param)[0],
                  {},
                  Kinetic
                );
                var $canvasContainer = $(".faceprofile-image", $_param);
                var parentWidth = $canvasContainer.parent().width(),
                  currentWidth = $canvasContainer.width();

                if (parentWidth < currentWidth) {
                  fp.width = parentWidth;
                  fp.height = parentWidth * 1.5;
                  $canvasContainer.css({
                    width: parentWidth,
                    height: parentWidth * 1.5,
                  });
                }

                $(".faceprofile-image", $_param).data("fp", fp);
              });
            }

            fp.load(d);
          });
        },

        get_detection_parameters: function ($_param, pi) {
          var id = $_param.attr("id"),
            data = _this.$el.data("operation");
          var $img = $(".selected-texture .faceprofile-image", $_param);
          var uuid = $img.data("id");
          var left = $(".orientation.orientation-left", $_param).hasClass(
            "selected"
          );

          if (left) {
            crop = pi.done({
              x: 0.05,
              w: 0.7,
              y: 0.05,
              h: 0.95,
            });
          } else {
            crop = pi.done({
              x: 0.25,
              w: 0.7,
              y: 0.05,
              h: 0.95,
            });
          }

          return {
            left: left,
            uuid: uuid,
            x: crop.crop_x,
            y: crop.crop_y,
            w: crop.crop_width,
            h: crop.crop_height,
          };
        },

        select_texture: function (event) {
          var $param = getParameter(this);
          var $img = $("img", this);

          if ($img.length == 0) {
            $img = $(this);
          }

          var id = $param.attr("id");
          var uuid = $img.data("id");

          args = {};
          args[id] = uuid;

          // Event.data.cb(args);
          $("[href=#accordion-" + id + "-two]").click();
          $(".selected-texture .faceprofile-image", $param)
            .removeClass(function (index, klass) {
              return (klass.match(/texture-[^ ]*/g) || []).join(" ");
            })
            .addClass("texture-" + uuid)
            .data("id", uuid)
            .data("src", $img.data("src"));
          $("#accordion-" + id + "-two .image-selected").attr(
            "src",
            $img.data("src")
          );
        },
      },
      designoperationfaceprofileparameterhanddraw: {
        init: function ($param) {
          var id = $param.data("parameter").id,
            data = _this.$el.data("operation"),
            paintCanvas = new PaintCanvas();

          paintCanvas.appendTo = $(".j-canvas-container", $param)[0];
          paintCanvas.width = $(".j-canvas-container", $param).width();
          paintCanvas.height = paintCanvas.width * 1.5;
          paintCanvas.init();
          $(".j-update-action", $param).on("click", function () {
            var d = paintCanvas.brush.get_plots(),
              aspect_ratio = paintCanvas.brush.get_aspectratio();
            var id = $param.attr("id");
            var opts = {};

            opts[id + ".profile"] = "[ " + d.toString() + " ]";
            opts[id + ".aspectratio"] = aspect_ratio;
            _this.update(opts);
            $(".wizard").wizard("enableNext");

            return false;
          });
        },
      },

      designoperationfaceprofileparameter: {
        init: function ($param) {
          var $scrollPick = $(
              ".texture-selection",
              $param
            ).SculpteoHorizontalPicker(),
            id = $param.data("parameter").id,
            data = _this.$el.data("operation");

          _this.media_upload($(".picker-add", $param), $param, "image");
          var id = $param.attr("id");
          var pdata = getControlParams("profile", id, data);

          if (data[id]) {
            $(".selected-texture", $param).show();
            parameters_class.designoperationfaceprofileparameter.update_faceprofile(
              $param,
              parameters_class.designoperationfaceprofileparameter.get_detection_parameters(
                $param,
                true
              )
            );
          } else {
            $(".texture-selection", $param).show();
          }

          $(".change-texture", $param).click(
            parameters_class.designoperationfaceprofileparameter.show_selection
          );
          $(".same-profile", $param).on("click", function () {
            $(".texture-control", $param).toggle();

            if ($(this).is(":checked")) {
              var opts = {};

              opts[id + ".profile"] = "";
              _this.update(opts);
              $(".wizard").wizard("enableNext");
            }
          });

          $($param).delegate(
            ".picker-scroll-content-item:not(.picker-add)",
            "click",
            parameters_class.designoperationfaceprofileparameter.select_texture
          );
          var left = false;

          $(".orientation.orientation-left", $param)
            .toggle(left)
            .click(function () {
              $(".orientation", $param).toggle();
              parameters_class.designoperationfaceprofileparameter.update_faceprofile(
                $param,
                parameters_class.designoperationfaceprofileparameter.get_detection_parameters(
                  $param,
                  false
                )
              );

              return false;
            });

          $(".orientation.orientation-right", $param)
            .toggle(!left)
            .click(function () {
              $(".orientation", $param).toggle();
              parameters_class.designoperationfaceprofileparameter.update_faceprofile(
                $param,
                parameters_class.designoperationfaceprofileparameter.get_detection_parameters(
                  $param,
                  false
                )
              );

              return false;
            });

          // Start in selection mode
          $(".change-texture", $param).click();
        },

        select_texture: function (event) {
          var $param = getParameter(this);
          var $img = $("img", this);

          if ($img.length == 0) {
            $img = $(this);
          }

          var id = $param.attr("id");
          var uuid = $img.data("id");

          args = {};
          args[id] = uuid;

          // Event.data.cb(args);
          $(".texture-selection", $param).hide();
          $(".selected-texture ", $param).show();
          $(".selected-texture .faceprofile-image", $param)
            .removeClass(function (index, klass) {
              return (klass.match(/texture-[^ ]*/g) || []).join(" ");
            })
            .addClass("texture-" + uuid)
            .data("id", uuid)
            .data("src", $img.data("src"));
          parameters_class.designoperationfaceprofileparameter.update_faceprofile(
            $param,
            parameters_class.designoperationfaceprofileparameter.get_detection_parameters(
              $param,
              false
            )
          );
        },

        get_detection_parameters: function ($_param, from_data) {
          var id = $_param.attr("id"),
            data = _this.$el.data("operation");

          if (from_data) {
            var data = _this.$el.data("operation");
            var param_data = getControlParams("profile", id, data);

            return {
              left: false,
              uuid: null,
            };
          } else {
            // Get values from widgets
            var $img = $(".selected-texture .faceprofile-image", $_param);
            var uuid = $img.data("id");

            return {
              left: $(".orientation.orientation-left", $_param).is(":visible"),
              uuid: uuid,
            };
          }
        },

        show_selection: function (event) {
          var $param = getParameter(this);

          $(".texture-selection, .profile-picture", $param).show();
          $(
            ".selected-texture, .profile-orientation, .profile-crop",
            $param
          ).hide();

          return false;
        },

        select_texture: function (event) {
          var $param = getParameter(this);
          var $img = $("img", this);

          if ($img.length == 0) {
            $img = $(this);
          }

          var id = $param.attr("id");
          var uuid = $img.data("id");

          args = {};
          args[id] = uuid;

          // Event.data.cb(args);
          $(".texture-selection", $param).hide();
          $(".selected-texture ", $param).show();
          $(".selected-texture .faceprofile-image", $param)
            .removeClass(function (index, klass) {
              return (klass.match(/texture-[^ ]*/g) || []).join(" ");
            })
            .addClass("texture-" + uuid)
            .data("id", uuid)
            .data("src", $img.data("src"));

          if (typeof use_profile_3dpcase == "undefined") {
            parameters_class.designoperationfaceprofileparameter.update_faceprofile(
              $param,
              parameters_class.designoperationfaceprofileparameter.get_detection_parameters(
                $param,
                false
              )
            );
          }
        },

        update_faceprofile: function ($_param, opts) {
          if (opts.uuid == null) {
            return;
          }

          if (!typeof use_profile_3dpcase != "undefined") {
            $(".faceprofile-image", $_param).attr("src", LOADER_URL);
          }

          $(".computing", $_param).show();
          $.getJSON(URLS["x_design_faceprofile_image"], opts, function (d) {
            $(".faceprofile-image", $_param).attr("src", d.url);
            var id = $_param.attr("id");
            var opts = {};

            opts[id + ".profile"] = "[ " + d.profile.toString() + " ]";
            opts[id + ".aspectratio"] = d.aspectratio;
            _this.update(opts);
            $(".computing", $_param).hide();
          });
        },
      },

      designoperationselectparameter: {
        init: function ($param) {
          var id = $param.data("parameter").id,
            data = _this.$el.data("operation");

          $("select", $param).on(
            "change",
            parameters_class.designoperationselectparameter.change
          );
          $("input[type=radio]", $param).on(
            "click",
            parameters_class.designoperationselectparameter.change
          );
          $("a[data-s-select]", $param).on(
            "click",
            parameters_class.designoperationselectparameter.change
          );
          $("select", $param).val(data[id]);
        },

        change: function (event) {
          var $param = getParameter(this);
          var id = $param.data("parameter").id;
          var data = {};

          data[id] = $(this).val() || $(this).data("s-select");
          _this.update(data);
        },
      },

      designoperationfontparameter: {
        init: function ($param) {
          var id = $param.data("parameter").id,
            data = _this.$el.data("operation");

          $("select", $param).change(
            parameters_class.designoperationfontparameter.change
          );
          $("select", $param).val(data[id]);
        },

        change: function (event) {
          var $param = getParameter(this),
            data = _this.$el.data("operation");
          var id = $param.attr("id");
          var data = {};

          data[id] = $(this).val();
          _this.update(data);
        },
      },

      designoperationdesignparameter: {
        init: function ($param) {
          var id = $param.data("parameter").id,
            data = _this.$el.data("operation");

          $(".design-selection", $param).on(
            "click",
            ".item",
            parameters_class.designoperationdesignparameter.select_design
          );
          $(".change-design", $param).on(
            "click",
            parameters_class.designoperationdesignparameter.show_selection
          );

          // Accesories 3Dpcase
          $("input[name=" + id + "], select[name=" + id + "]").on(
            "change",
            function () {
              var data = {};

              data[id] = $(this).val();
              _this.update(data);
            }
          );

          var id = $param.attr("id");

          if (data[id]) {
            $(".selected-design", $param).show();
          } else {
            $(".design-selection", $param).show();
          }
        },

        show_selection: function (event) {
          var $param = getParameter(this);

          $(".design-selection", $param).show();
          $(".selected-design", $param).hide();

          return false;
        },

        select_design: function (event) {
          var $param = getParameter(this);
          var design = $(this).data("design");
          var id = $param.attr("id");
          var data = {};

          data[id] = design.uuid;
          _this.update(data);
          $(".selected-design .the-design img", $param).attr(
            "src",
            design.thumbnail
          );
          $(".selected-design .the-design span", $param).text(design.name);
          $(".design-selection", $param).hide();
          $(".selected-design", $param).show();
        },
      },

      designoperationcolorparameter: {},
    };

    $(".parameters_config .add-param-button", this.$el).click(function () {
      var identifier = $("[name=param_identifier]", _this.$el).val();
      var descr_en = $("[name=param_description_en]", _this.$el).val();
      var descr_fr = $("[name=param_description_fr]", _this.$el).val();
      var descr_de = $("[name=param_description_de]", _this.$el).val();
      var type = $(".param_type", _this.$el).val();
      var data = {};

      data[identifier + ".type"] = type;
      data[identifier + ".description_fr"] = descr_fr;
      data[identifier + ".description_en"] = descr_en;
      data[identifier + ".description_de"] = descr_de;

      _this.update(data).then(function () {
        var typename = $(".parameters_config .template-" + type).attr("id");
        var param = $($(".parameters_config .template-" + type).html());

        if (LANG == "en") {
          $(".param_description", param).text(descr_en);
        } else if (LANG == "fr") {
          $(".param_description", param).text(descr_fr);
        } else if (LANG == "de") {
          $(".param_description", param).text(descr_de);
        }

        param.attr("id", identifier);
        $(".parameters", _this.$el).append(param);

        if (parameters_class[typename] && parameters_class[typename].init) {
          $param = $(".parameters #" + identifier);
          parameters_class[typename].init($param);
        }
      });
    });

    $(".parameters", this.$el).delegate(
      ".del-param-button",
      "click",
      function () {
        var $param = getParameter(this);
        var identifier = $param.attr("id");
        var data = {};

        data[identifier + ".type"] = 0;
        $param.html("");
        _this.update(data);
      }
    );

    for (klass in parameters_class) {
      $(".parameters ." + klass, this.$el).each(function () {
        var $param = $(this);

        parameters_class[klass].init($param);
      });
    }

    this.binded = true;
  },

  refresh_material: function () {
    var _this = this;

    $(".material-picker", this.$el).html('<div class="loader16 "></div>');
    var url = URLS["x_get_materials"];

    if ($(".material-picker", this.$el).hasClass("texture-only")) {
      url += "?texture_only=1";
    }

    $.get(
      url,
      {
        uuid: _this.design.model_uuid
          ? _this.design.model_uuid
          : _this.design.design_uuid,
      },
      function (data, textStatus, jqXHR) {
        $(".material-picker", _this.$el).each(function (idx, el) {
          if ($(el).hasClass("texture-only")) {
            var d = $(data);

            $(".colors", d).hide();
            $(el).html(d);
          } else {
            $(el).html(data);
          }
        });

        if (_this.is_wizard) {
          _this.parent.resize();
        }
      }
    );
  },

  data: function (field) {
    return this.$el.data("operation")[field];
  },

  show: function () {
    if (!this.binded) {
      this.bind();
    }

    return this;
  },

  viewer_click: function (pos) {},

  color_wheel: function ($div, options) {
    var opts = {};
    opts["text_color_r"] = 0;
    opts["text_color_g"] = 0;
    opts["text_color_b"] = 0;
    this.update(opts);
  },

  media_upload: function (
    $el,
    $container,
    media_type,
    input_type,
    filedata,
    must_confirm
  ) {
    if (media_type == "audio" && input_type == "record") {
      upload_type = "audio";
    } else {
      upload_type = "file";
    }

    var success = function (key) {
      $.getJSON(
        URLS["x_new_media"],
        { key: key, type: media_type },
        function (data) {
          if (data.error) {
            jAlert("" + data.error, gettext("Error"));

            return;
          }

          var d = data;

          if (media_type == "audio") {
            var $d = $("<div></div>")
              .append(
                $("<div></div>", { class: "audioButton", href: data.url }).text(
                  data.name
                )
              )
              .append(
                $("<a></a>", { class: "audioSelect audio-" + data.uuid }).text(
                  gettext("Select")
                )
              );

            $(".audio-selection").SculpteoHorizontalPicker("add", {
              after: ".picker-add",
              el: $d,
              class: "audio",
            });
            $(".audio-" + data.uuid, $container).click();
          } else if (media_type == "font") {
            $(".SelectFont").append(
              "<option value='" +
                data.uuid +
                "'>" +
                Utils.escapeHTML(data.name) +
                "</option>"
            );
            $(".SelectFont", $container).val(data.uuid).change();
            Utils.popupMessage(
              "'" +
                Utils.escapeHTML(data.name) +
                "' " +
                gettext("is now available for writing text"),
              "hint"
            );
          } else {
            var loader = new ImageLoader(data.thumbnail);

            loader.loadEvent = function (imageUrl, image) {
              if ($el.data("template")) {
                var $clone = $($($el.data("template")).html());
                var $img = $("img", $clone),
                  $sel = $("[data-selector]", $clone);

                $sel.data({ id: d.uuid, src: d.url });
                $img.attr("src", imageUrl);
                $clone.insertBefore($el);
                $clone.show();
                $sel.click();
              } else {
                image.title = d.name;
                image.alt = d.name;
                image.setAttribute("data-id", d.uuid);
                image.setAttribute("data-src", d.url);
                image.width = 45;
                image.height = 45;

                // Add and simulate click on texture
                if (!$(".texture-selection-bs").length) {
                  $(".texture-selection").SculpteoHorizontalPicker("add", {
                    after: ".picker-add",
                    el: image,
                  });
                }

                $(".texture-gallery:not(.permanent)").each(function () {
                  if ($("img", $(this)).length) {
                    $(image)
                      .clone()
                      .insertBefore($("img", $(this)).first());
                  } else {
                    $(image).clone().appendTo($(this));
                  }
                });

                // Simulate click on texture
                $("img[data-id=" + d.uuid + "]", $container).click();
              }
            };

            loader.load();
          }
        }
      );
    };

    if (filedata) {
      return $.ajax({
        url: URLS["upload_file"],
        data: { file: filedata, filename: "picture.png" },
        success: function (resp) {
          log("key  " + resp.key);
          success(resp.key);
        },

        dataType: "json",
        type: "POST",
      });
    }

    $el.hidden_upload_button({
      type: upload_type,
      ready: function () {},

      success: function (key) {
        if (must_confirm) {
          jConfirm(
            gettext("I confirm I have the right to use the image I uploaded."),
            "Confirmation",
            function (r) {
              if (r) {
                success(key);
              }
            }
          );
        } else {
          success(key);
        }
      },

      error: function (msg) {
        jAlert("" + msg, gettext("Error"));
      },
    });
  },

  slider: function ($div, options) {
    if (Object.size(options) == 1 && typeof o["value"] != "undefined") {
      $(".the-slider", $div).slider(o);

      return;
    }

    var _this = this;
    var defaults = {
      orientation: "horizontal",
      precision: 0,
      slide: function (evt, ui) {
        $(".text-value", $(this).closest(".slider-control")).text(
          ui.value.toFixed(options.precision)
        );
      },

      change: function (evt, ui) {
        $(".text-value", $(this).closest(".slider-control")).text(
          ui.value.toFixed(options.precision)
        );
      },

      stop: function (evt, ui) {
        var param = $div.data("controlled-param");
        var opts = {};

        opts[param] = ui.value;
        _this.update(opts);

        if (options.cb) {
          options.cb();
        }
      },
    };
    var options = $.extend(defaults, options);

    if (typeof options["controlled_param"] != "undefined") {
      $div.data("controlled-param", options["controlled_param"]);
    }

    if (typeof options["reset_value"] != "undefined") {
      $div.data("reset-value", options["reset_value"]);
    }

    if (typeof options["value"] != "undefined") {
      $div.data("default-value", options["value"]);
      $(".text-value", $div).text(options["value"]);
    }
    /*		If (typeof(options['change_value']) != 'undefined') {
					$(".the-slider", this).slider("value", options['change_value']);
					var param = $(this).closest(".slider-control").data("controlled-param");
					var opts = {} ; opts[param] = options['change_value'];
					callChangeOperation(opts);
					return ;
				} */

    $(".slider-reset", $div)
      .unbind("click")
      .click(function (evt) {
        var opts = {};
        var param = $div.data("controlled-param");

        if (typeof $div.data("reset-value") != "undefined") {
          opts[param] = $div.data("reset-value");
        } else {
          opts[param] = $div.data("default-value");
        }

        _this.update(opts);
        $(".the-slider", $div).slider("option", "value", opts[param]);

        return false;
      });

    return $(".the-slider", $div).slider(options);
  },

  crop_texture: function (prefix, $el) {
    if (!$el) {
      $el = this.$el;
    }

    var imageSrc = $(".image-src", $el).text(),
      _this = this;

    if (!prefix) {
      prefix = "";
    }

    if (!imageSrc) {
      return;
    }

    var loader = new ImageLoader(imageSrc);

    loader.loadEvent = function (imageUrl, img) {
      var w = img.width,
        h = img.height;

      if (w > 128 && h <= w) {
        h = (h * 128) / w;
        w = 128;
      } else if (h > 128 && h > w) {
        w = (w * 128) / h;
        h = 128;
      }

      $(".image-content", $el).empty().append(img);
      $(".image-content img", $el)
        .attr({
          width: w,
          height: h,
        })
        .removeClass("crop-img");

      // Test for presence of image-crop. If it's not present, it means the crop field is locked
      // if ($(".image-crop", $el).length && $(".image-crop", $el).text() != '') {
      // XXX: should be dynamically updated depending on lock state
      if (_this.is_modifiable_field("crop")) {
        $(".image-content img", $el).Jcrop({
          onSelect: function setCoords(c) {
            args = {};
            args[prefix + "x"] = c.x / w;
            args[prefix + "y"] = c.y / h;
            args[prefix + "w"] = c.w / w;
            args[prefix + "h"] = c.h / h;

            if (_this.is_modifiable_field("crop")) {
              _this.update(args);
            }
          },

          setSelect: [
            w * parseFloat(_this.data(prefix + "x")),
            h * parseFloat(_this.data(prefix + "y")),
            w *
              (parseFloat(_this.data(prefix + "x")) +
                parseFloat(_this.data(prefix + "w"))),
            h *
              (parseFloat(_this.data(prefix + "y")) +
                parseFloat(_this.data(prefix + "h"))),
          ],
        });
      }
    };

    setTimeout(function () {
      loader.load();
    }, 100);
  },
};

SculpteoOperationUI.PrintDesignOperation = function ($el, design, operation) {
  this._super(undefined, $el, design, operation);
  this.current_focus = null;
}.extend(SculpteoOperationUI, {
  bind: function () {
    var _this = this;

    this._super("bind");
    $(".available-materials, [data-selector=material]", this.$el).on(
      "click",
      ".item, [data-selector=material-item]",
      function () {
        var material = new Material($(this).data("material"));
        _this.design.update_material(material);
        if (material.finish) _this.design.order.finish = material.finish;
        $(
          ".available-materials .item, [data-selector=material-item]",
          _this.$el
        ).removeClass("selected");
        $(this).addClass("selected");

        // Close open categories if it's not inside one
        $(".category", _this.$el)
          .not($(this).closest(".category"))
          .addClass("collapsed");

        if (_this.design.material) {
          $("#create-wizard .hint").toggle();
        }

        return false;
      }
    );

    $(".ScaleSlider", this.$el).slider({
      orientation: "horizontal",
      value: _this.design.size.userScale,
      min: 0,
      max: 5,
      step: 0.01,
      slide: function (evt, ui) {
        _this.update_scale(ui.value, false, false);
        _this.update_xyz();
        _this.update_weight();
      },
    });

    if (typeof materialUI != "undefined") {
      materialUI.update_scale_slider();
    }

    $(".size", this.$el).on("keyup", function () {
      var newScale =
        parseFloat(
          $(this)
            .val()
            .replace(/\,/g, ".")
            .replace(/([^0-9\.])/g, "")
        ) / _this.design.size[$(this).attr("name")];

      if (!isNaN(newScale)) {
        _this.update_scale(newScale, false, false);
        _this.update_xyz($(this));
        _this.update_weight();
      }
    });

    $(".Scale100", this.$el).on("click", function () {
      _this.update_scale(
        _this.design.original_size.userScale,
        _this.design.original_size.unit,
        false
      );
      _this.update_xyz($(this));
      _this.update_weight();
    });

    $(".ScaleValue", this.$el).change(function () {
      var newScale = parseFloat(eval($(this).val()));

      if (isNaN(newScale)) {
        $(this).val((_this.design.size.userScale * 100).toFixed(0));

        return;
      }

      newScale /= 100;
      _this.update_scale(newScale, false, false);
      _this.update_xyz($(this));
      _this.update_weight();
    });

    $("[name=unit]", this.$el).on("change", function () {
      _this.update_scale(false, $(this).val(), false);
      _this.update_weight();
    });

    $(".fixed-size [type=radio]", this.$el).on("change", function () {
      var scale_info = $(this).data("scale"),
        scale = scale_info ? scale_info.scale : false,
        unit = scale_info ? scale_info.unit : false;

      _this.update_scale(scale, unit, parseInt($(this).val()));
      _this.update_weight();
    });

    // Material accordions
    $(".available-materials .category .header", this.$el).click(function () {
      var $cat = $(this).closest(".category");

      if ($cat.hasClass("collapsed")) {
        $(".category", _this.$el).not($cat).addClass("collapsed");
        $cat.removeClass("collapsed");
      } else {
        $cat.addClass("collapsed");
      }
    });

    $(".ScaleValue", _this.$el).tooltip({
      bodyHandler: function () {
        return $(".scale_tooltip", _this.$el).html();
      },

      showURL: false,
    });
    this.update_display();
  },

  update_display: function () {
    var fixed = this.design.size.fixed(),
      _this = this;

    $.each(["x", "y", "z"], function (i, elt) {
      $("[name=" + elt + "]", _this.$el).val(fixed[elt]);
    });

    var scaleValue = (this.design.size.userScale * 100).toFixed(5);

    scaleValue = scaleValue.replace(/0+$/, "").replace(/\.$/, "");
    $(".ScaleValue", this.$el).val(scaleValue);
    $("[name=unit]", this.$el).val(this.design.size.unit);
    $(".ScaleSlider", this.$el).slider(
      "option",
      "value",
      this.design.size.userScale
    );
  },

  update_scale: function (userscale, unit, size_id) {
    var _this = this;

    $(".Button-series").addClass("disabled");
    _this.design.update_scale(userscale, unit, size_id);
  },

  update_xyz: function (el) {
    var fixed = this.design.size.fixed(),
      _this = this;

    $.each(["x", "y", "z"], function (i, elt) {
      if (elt != $(el).attr("name")) {
        $("[name=" + elt + "]").val(fixed[elt]);
      }
    });

    var scaleValue = (this.design.size.userScale * 100).toFixed(5);

    scaleValue = scaleValue.replace(/0+$/, "").replace(/\.$/, "");
    $(".ScaleValue", this.$el).val(scaleValue);

    if (el) {
      $(".ScaleSlider", this.$el).slider(
        "option",
        "value",
        this.design.size.userScale
      );
    }
  },

  update_weight: function (el) {
    if (
      this.design.material &&
      this.design.material.density &&
      this.design.volume &&
      this.material.slug.startsWith("metal_")
    ) {
      var density = this.design.material.density;
      var base_volume = this.design.volume;
      var coef = this.design.size.userScale * this.design.size.unitFactor(); // To cm
      var volume = base_volume * coef * coef * coef;
      var weight = volume * density;

      $(".print-weight").html(weight.toFixed(1) + " g");
      $(".weight").show();
    } else {
      $(".weight").hide();
    }
  },
});

SculpteoOperationUI.WriteTextDesignOperation = function (
  $el,
  design,
  operation,
  options
) {
  this._super(undefined, $el, design, operation, options);
}.extend(SculpteoOperationUI, {
  bind: function () {
    var _this = this;

    this._super("bind");
    $(".SelectFont", this.$el)
      .on("change", function () {
        _this.update({ o_font: $(this).val() });

        // $(".del-font-button", this.$el).toggle(! $("option:selected", this.$el).hasClass("public"));
      })
      .val(this.data("o_font"));

    // $(".del-font-button", this.$el).toggle(! $("option:selected", this.$el).hasClass("public"));
    this.media_upload($(".add-font-button", this.$el), this.$el, "font");
    $(".add-font-button", this.$el)
      .tooltip({
        delay: 0,
        fade: 250,
        bodyHandler: function () {
          return gettext("Add a new font (.ttf)");
        },

        showURL: false,
      })
      .show();

    $(".del-font-button", this.$el)
      .click(function () {
        var id = $(".SelectFont", $op).val();

        $.getJSON(URLS["x_del_font"], { id: id }, function (data) {
          if (data.error) {
            return;
          }

          var option = $(".SelectFont option[value=" + id + "]", $op);
          var name = option.html();

          option.addClass("hidden");
          $(".SelectFont", $op)
            .val($(".SelectFont .public", $op).attr("value"))
            .change();
          Utils.popupMessage("'" + name + "' " + gettext("removed"), "hint");
        });
      })
      .tooltip({
        delay: 0,
        fade: 250,
        bodyHandler: function () {
          return gettext("Delete font");
        },

        showURL: false,
      });

    $(".InputText", this.$el).on("change", function (event) {
      if (_this.small) {
        $(".value", _this.small).text($(this).val());
      }
    });
  },

  wizard: function (parent) {
    $(".size-div", this.$el).hide();
    this.$el.data("operation").str = "";
    $(".InputText", this.$el).val("");

    return this._super("wizard", parent);
  },

  validate: function () {
    if (!this.$el.data("operation").str) {
      this.show_help("help_enter_text", false);

      return false;
    }

    return true;
  },

  viewer_click: function (pos) {
    if (this.is_modifiable_field("position")) {
      this.update(pos);
    }

    if (this.is_wizard) {
      this.create_operation();
    }
  },
});

SculpteoOperationUI.TemplatedTextDesignOperation = function (
  $el,
  design,
  operation,
  options
) {
  this._super(undefined, $el, design, operation, options);
}.extend(SculpteoOperationUI.WriteTextDesignOperation, {});

SculpteoOperationUI.LogoDesignOperation = function (
  $el,
  design,
  operation,
  options
) {
  this._super(undefined, $el, design, operation, options);
}.extend(SculpteoOperationUI, {
  bind: function () {
    var _this = this;

    this._super("bind");

    this.media_upload($(".upload-image", this.$el), this.$el, "image");

    $(".texture-gallery", this.$el).on("click", "img", function () {
      _this.update({ o_logo: $(this).data("id") });
      _this.update_extrusion_view();
      _this.select_step(2);
    });

    this.slider($(".contrast-slider", this.$el), {
      min: 0,
      max: 100,
      step: 1,
      controlled_param: "contrast_threshold",
      value: this.data("contrast_threshold"),
      cb: function () {
        _this.update_extrusion_view();
      },
    }).slider("option", "disabled", this.data("contrast_threshold_automatic"));
    this.slider($(".detail-slider", this.$el), {
      min: 0,
      max: 200,
      step: 1,
      controlled_param: "detail_threshold",
      value: this.data("detail_threshold"),
      cb: function () {
        _this.update_extrusion_view();
      },
    }).slider("option", "disabled", this.data("detail_threshold_automatic"));

    $(".contrast-auto", this.$el).on("click", function () {
      var auto = $(this).hasClass("contrast-auto-on");

      $(".contrast-auto", _this.$el).toggle();
      $(".contrast-slider .the-slider", _this.$el).slider(
        "option",
        "disabled",
        !auto
      );
      _this.update({ contrast_threshold_automatic: !auto });
      _this.update_extrusion_view();

      return false;
    });

    $(".contrast-slider .contrast-auto-on", this.$el).toggle(
      this.data("contrast_threshold_automatic")
    );
    $(".contrast-slider .contrast-auto-off", this.$el).toggle(
      !this.data("contrast_threshold_automatic")
    );

    $(".detail-auto", this.$el).on("click", function () {
      var auto = $(this).hasClass("detail-auto-on");

      $(".detail-auto", _this.$el).toggle();
      $(".detail-slider .the-slider", _this.$el).slider(
        "option",
        "disabled",
        !auto
      );
      _this.update({ detail_threshold_automatic: !auto });
      _this.update_extrusion_view();

      return false;
    });

    $(".detail-slider .detail-auto-on", this.$el).toggle(
      this.data("detail_threshold_automatic")
    );
    $(".detail-slider .detail-auto-off", this.$el).toggle(
      !this.data("detail_threshold_automatic")
    );

    $(".colorize", this.$el).on("click", function () {
      $(".color-extrusion-control", _this.$el).toggle($(this).is(":checked"));
    });

    $(".color-extrusion-control", this.$el).toggle(this.data("usecolors"));

    $(".toolbox-back-step1", this.$el)
      .show()
      .on("click", function () {
        _this.update({ o_logo: null });
        _this.select_step(1);

        return false;
      });

    _this.select_step(this.data("o_logo") == null ? 1 : 2);

    // $(".switch-3D", $this).click({cb: callback_texture}, internal_logo.switch_view_click);
  },

  update_extrusion_view: function () {
    var _this = this;

    if (_this.data("o_logo")) {
      var viewer_uuid = _this.$el.data("viewer-uuid");

      // 3D viewer is active, refresh extruded design
      if (viewer_uuid) {
        var url = $.param.querystring(
          URLS["extruded_texture"],
          $.extend({}, d, { uuid: viewer_uuid, mask_id: d["mask"] })
        );

        $(".extrusionImage, .switch-3D-on", $this).hide();
        $(".switch-2D-on", $this).show();
        $(".extrusionViewer", $this).show().Sculpteo3DViewer({
          src: url,
          uuid: viewer_uuid,
          material: "white_plastic",
        });
      } else {
        // 2D viewer is active, refresh 2D view
        $(".extrusionViewer, .switch-2D-on", _this.$el).hide();
        $(".extrusionImage, .switch-3D-on", _this.$el).show();
        $.getJSON(
          URLS["x_design_vectorized_image"],
          {
            contrast_threshold: _this.data("contrast_threshold"),
            contrast_threshold_automatic: _this.data(
              "contrast_threshold_automatic"
            ),
            detail_threshold: _this.data("detail_threshold"),
            detail_threshold_automatic: _this.data(
              "detail_threshold_automatic"
            ),
            o_logo: _this.data("o_logo"),
            methodid: _this.data("methodid"),
            mask_id: _this.data("mask"),
          },
          function (d) {
            $(".vectorized-image", _this.$el).attr("src", d.url);
            $(".original-image", _this.$el).attr("src", d.original);
          }
        );
      }
    }
  },

  wizard: function (parent) {
    $(".size-div", this.$el).hide();
    this.$el.data("operation").o_logo = null;
    this.select_step(1);

    return this._super("wizard", parent);
  },

  validate: function () {
    if (!this.$el.data("operation").o_logo) {
      this.show_help("help_no_logo_selected", false);

      return false;
    }

    return true;
  },

  viewer_click: function (pos) {
    if (this.is_modifiable_field("position")) {
      this.update(pos);
    }

    if (this.is_wizard) {
      this.create_operation();
    }
  },
});

SculpteoOperationUI.SymbolDesignOperation = function (
  $el,
  design,
  operation,
  options
) {
  this._super(undefined, $el, design, operation, options);
}.extend(SculpteoOperationUI, {
  bind: function () {
    var _this = this;

    this._super("bind");
    $(".SelectSymbol", this.$el)
      .on("change", function () {
        var font_id = $(this).val();

        $(".char-map", _this.$el).hide();
        _this.highligh_map($(".char-map-" + font_id, _this.$el).show());
        var area = $(".char-map-" + font_id, _this.$el)
          .find("area")
          .first();

        _this.hover_area(area);
        _this.update({
          str: area.attr("accesskey"),
          o_font: font_id,
        });

        if (_this.small) {
          $(".thumbnail", _this.small).attr(
            "src",
            URLS["font_char_image"] +
              "?font_id=" +
              _this.data("o_font") +
              "&char=" +
              _this.data("str")
          );
        }
      })
      .val(this.data("o_font"));

    $("area", this.$el).on("click", function () {
      _this.hover_area($(this));
      _this.update({ str: $(this).attr("accesskey") });

      if (_this.small) {
        $(".thumbnail", _this.small).attr(
          "src",
          URLS["font_char_image"] +
            "?font_id=" +
            _this.data("o_font") +
            "&char=" +
            _this.data("str")
        );
      }

      return false;
    });

    $(".char-map", this.$el).hide();
    var charmap = $(".char-map-" + this.data("o_font"), this.$el).show();

    this.hover_area($("[accesskey=" + this.data("str") + "]", charmap));
    this.highligh_map(charmap);
  },

  highligh_map: function (map) {
    if (!$.browser.msie) {
      // Damn IE. Image won't display if hidden -> hilight -> show ...
      map.find("img").maphilight({ strokeColor: "1c85e0" });
    }
  },

  hover_area: function (area) {
    var coords = $(area).attr("coords"),
      _this = this;

    if (coords) {
      coords = coords.split(",");

      if (!$.browser.msie) {
        $(".charmap-hover", _this.$el)
          .css({ top: coords[1] + "px", left: coords[0] + "px" })
          .show();
      } else {
        $(".charmap-hover-ie", _this.$el)
          .css({ top: coords[1] + "px", left: coords[0] + "px" })
          .show();
      }
    }
  },

  wizard: function (parent) {
    $(".size-div", this.$el).hide();

    // $(".SelectSymbol", this.$el).val($(".SelectSymbol option:first", this.$el).attr("value"))
    return this._super("wizard", parent);
  },

  viewer_click: function (pos) {
    if (this.is_modifiable_field("position")) {
      this.update(pos);
    }

    if (this.is_wizard) {
      this.create_operation();
    }
  },
});

SculpteoOperationUI.ColorizeDesignOperation = function (
  $el,
  design,
  operation,
  options
) {
  this._super(undefined, $el, design, operation, options);
}.extend(SculpteoOperationUI, {
  bind: function () {
    var _this = this;

    this._super("bind");
    this.color_wheel($(".color1", this.$el), {
      controlled_param: "color",
      value: {
        r: this.data("color_r"),
        g: this.data("color_g"),
        b: this.data("color_b"),
      },
      color_feedback: function (color) {
        if (_this.small) {
          $(".first-color", _this.small).css("background-color", color);
        }
      },
    });
    this.color_wheel($(".color2", this.$el), {
      controlled_param: "color",
      color_suffix: "2",
      value: {
        r: this.data("color_r2"),
        g: this.data("color_g2"),
        b: this.data("color_b2"),
      },
      color_feedback: function (color) {
        if (_this.small) {
          $(".second-color", _this.small).css("background-color", color);
        }
      },
    });

    var gradient_on_click = function () {
      if ($(this).is(":checked")) {
        $(".toolbox-apply-or-replace", _this.$el).hide();

        if (_this.small) {
          $(".second-color", _this.small).show();
        }

        $(".gradient-param, .gradient-param-help", _this.$el).show();
      } else {
        $(".toolbox-apply-or-replace", _this.$el).show();

        if (_this.small) {
          $(".second-color", _this.small).hide();
        }

        $(".gradient-param, .gradient-param-help", _this.$el).hide();
      }
    };

    $("[name=gradient]", this.$el).on("click", gradient_on_click);
    gradient_on_click.call($("[name=gradient]", this.$el));

    $(".toolbox-apply", this.$el).on("click", function () {
      if (_this.is_wizard) {
        _this.create_operation();
      }
    });
  },

  viewer_click: function (pos) {
    if (this.is_modifiable_field("position") && this.data("gradient")) {
      this.update({
        direction_x: pos.direction_x,
        direction_y: pos.direction_y,
        direction_z: pos.direction_z,
      });
    }

    if (this.is_wizard) {
      this.create_operation();
    }
  },
});

SculpteoOperationUI.TextureOperation = function (
  $el,
  design,
  operation,
  options
) {
  this._super(undefined, $el, design, operation, options);
}.extend(SculpteoOperationUI, {
  bind: function () {
    var _this = this;

    this._super("bind");
    this.media_upload($(".upload-image", this.$el), this.$el, "image");
    $(".texture-gallery", this.$el).on("click", "img", function () {
      _this.update({ texture: $(this).data("id") });
      _this.select_step(2);
      $(".image-src", _this.$el).text($(this).data("src"));
      _this.crop_texture();
    });

    $(".removefile", this.$el).on("click", function () {
      _this.update({ texture: null });
      _this.select_step(1);
      $(".image-src", _this.$el).text("");

      return false;
    });

    _this.select_step(this.data("texture") != null ? 2 : 1);

    if (this.data("texture") != null) {
      this.crop_texture();
    }
  },

  wizard: function (parent) {
    $(".size-div", this.$el).hide();
    this.$el.data("operation").texture = null;
    this.select_step(1);

    return this._super("wizard", parent);
  },

  validate: function () {
    if (!this.data("texture")) {
      this.show_help("help_upload_texture", false);

      return false;
    }

    return true;
  },

  viewer_click: function (pos) {
    if (this.is_modifiable_field("position")) {
      this.update(pos);
    }

    if (this.is_wizard) {
      this.create_operation();
    }
  },
});

SculpteoOperationUI.ReplaceTextureOperation = function (
  $el,
  design,
  operation,
  options
) {
  this._super(undefined, $el, design, operation, options);
}.extend(SculpteoOperationUI, {
  bind: function () {
    var _this = this;

    this._super("bind");

    $(".material-picker", this.$el).on(
      "click",
      ".texture-selection img",
      function () {
        _this.material_select($(this).data("id"));
      }
    );

    $(".material-picker", this.$el).on(
      "hover",
      ".texture-selection",
      function () {
        $(this).toggleClass("border-red");
      }
    );

    this.media_upload($(".upload-image", this.$el), this.$el, "image");
    $(".texture-gallery", this.$el).on("click", "img", function () {
      _this.update({ texture: $(this).data("id") });
      _this.select_step(3);
      $(".image-src", _this.$el).text($(this).data("src"));
      _this.crop_texture();
    });

    $(".back-step2", this.$el).on("click", function () {
      _this.update({ texture: null });
      _this.select_step(2);
      $(".image-src", this.$el).text("");

      return false;
    });

    $(".back-step1", this.$el).on("click", function () {
      _this.update({ texture: null, material_id: null });
      _this.select_step(1);
      $(".image-src", this.$el).text("");
      _this.show_texture(-1);

      return false;
    });

    this.slider($(".size-slider", this.$el), {
      min: 0,
      max: 1.0,
      step: 0.001,
      controlled_param: "size",
      value: this.data("size"),
    });

    // Internal_replace_texture.set_initial($this, data_op);
    this.crop_texture();

    if (this.data("texture") != null) {
      if (this.data("material_id") >= 0) {
        _this.select_step(3);
      } else {
        // Internal.refreshMaterial();
        _this.select_step(2);
      }
    } else {
      _this.select_step(1);
    }

    $(".apply-button", this.$el).on("click", function () {
      if (_this.is_wizard) {
        _this.create_operation();
      }
    });
  },

  show: function () {
    this.refresh_material();

    if (!this.binded) {
      this.bind();
    }

    return this;
  },

  material_select: function (material_id) {
    this.update({ material_id: material_id });
    this.select_step(2);
    this.show_texture(material_id);
  },

  show_texture: function (material_id) {
    var _this = this;

    if (material_id < 0) {
      $(".show-original-texture-url", _this.$el).hide();

      return;
    }

    var url = URLS["x_get_material"] + material_id;

    $.get(
      url,
      {
        uuid: _this.design.model_uuid
          ? _this.design.model_uuid
          : _this.design.design_uuid,
      },
      function (data, textStatus) {
        if (data.type == "texture") {
          $(".show-original-texture-url", _this.$el).show();
          $(".show-original-texture-url img", _this.$el).attr(
            "src",
            data.thumb_url
          );
          $(".show-original-texture-url a", _this.$el).attr("href", data.url);
        }
      }
    );
  },

  viewer_click: function (pos) {
    var _this = this;

    if (this.step == 1) {
      $.extend(pos, { uuid: this.design.model_uuid });
      $.getJSON(URLS["x_get_face_material"], pos, function (resp) {
        if (resp.material != null && resp.type == "texture") {
          _this.material_select(resp.material);
        } else {
          Utils.popupMessage(
            gettext("No texture found. Please click on a texture."),
            "warning"
          );
        }
      });
    }
  },

  wizard: function (parent) {
    $(".apply-button", this.$el).show();
    this.select_step(1);
    this.$el.data("operation").texture = null;
    this.$el.data("operation").material_id = null;

    return this._super("wizard", parent);
  },
});

SculpteoOperationUI.ChangePaletteColorOperation = function (
  $el,
  design,
  operation,
  options
) {
  this._super(undefined, $el, design, operation, options);
}.extend(SculpteoOperationUI, {
  bind: function () {
    var _this = this;

    this._super("bind");

    this.color_wheel($(".color", this.$el), {
      controlled_param: "color",
      value: {
        r: this.data("color_r"),
        g: this.data("color_g"),
        b: this.data("color_b"),
      },
      color_feedback: function (color) {
        if (_this.small) {
          $(".color", _this.small).css("background-color", color);
        }
      },
    });
    $(".material-picker", this.$el)
      .on("click", ".material", function () {
        $(".material", _this.$el).removeClass("border-red");
        $(this).addClass("border-red");
        _this.update({ material_id: $(this).data("id") });
        _this.select_step(2);
      })
      .on("hover", ".material", function () {
        $(this).toggleClass("border-white");
      });

    $(".material-" + this.data("material_id"), this.$el).addClass("border-red");
    this.select_step(this.data("material_id") != null ? 2 : 1);
    $(".apply-button", this.$el).on("click", function () {
      if (_this.is_wizard) {
        _this.create_operation();
      }
    });
  },

  viewer_click: function (pos) {
    var _this = this;

    if (this.step == 1) {
      $.extend(pos, { uuid: this.design.model_uuid });
      $.getJSON(URLS["x_get_face_material"], pos, function (resp) {
        if (resp.material != null) {
          _this.update({ material_id: resp.material });
          _this.select_step(2);
        } else {
          Utils.popupMessage(
            gettext("No color or image found at this place."),
            "warning"
          );
        }
      });
    }
  },

  show: function () {
    this.refresh_material();

    if (!this.binded) {
      this.bind();
    }

    return this;
  },

  wizard: function (parent) {
    $(".apply-button", this.$el).show();
    this.select_step(1);
    this.$el.data("operation").material_id = null;

    return this._super("wizard", parent);
  },
});

SculpteoOperationUI.SubdivisionOperation = function (
  $el,
  design,
  operation,
  options
) {
  this._super(undefined, $el, design, operation, options);
}.extend(SculpteoOperationUI, {
  bind: function () {
    var _this = this;

    this._super("bind");
    $(".toolbox-apply", this.$el).on("click", function () {
      if (_this.is_wizard) {
        _this.create_operation();
      }
    });
  },
});

SculpteoOperationUI.CubifyDesignOperation = function (
  $el,
  design,
  operation,
  options
) {
  this._super(undefined, $el, design, operation, options);
}.extend(SculpteoOperationUI, {
  bind: function () {
    var _this = this;

    this._super("bind");
    $(".toolbox-apply", this.$el).on("click", function () {
      if (_this.is_wizard) {
        _this.create_operation();
      }
    });
  },
});

SculpteoOperationUI.ScriptOperation = function (
  $el,
  design,
  operation,
  options
) {
  this._super(undefined, $el, design, operation, options);
}.extend(SculpteoOperationUI, {
  bind: function () {
    var _ed = {};
    var _this = this;

    this._super("bind");

    // ScriptOperation is no longer exposed in the UI, so we don't care if it fails
    require_fail(["ace/ace"], function () {
      $(".script").each(function (i, obj) {
        obj.setAttribute("id", "ed_" + i);
        _ed["ed_" + i] = ace.edit("ed_" + i);
        _ed["ed_" + i].setTheme("ace/theme/eclipse");
        _ed["ed_" + i].getSession().setMode("ace/mode/javascript");
      });

      $(".script", this.$el).on("click", function () {
        $(this)
          .closest(".configurable-field-type-script")
          .css({
            position: "absolute",
            zIndex: "10000",
          })
          .animate(
            {
              top: "60px",
              left: "-280px",
            },
            {
              duration: 500,
              complete: function () {
                $(this).css({
                  position: "absolute",
                  zIndex: "10000",
                });
              },
            }
          );

        $(this).animate(
          {
            width: "560px",
            height: "400px",
          },
          {
            duration: 500,
            complete: function () {
              _ed[$(this)[0].id].resize();
            },
          }
        );
        $(".toolbox-reduce", _this.$el).show();
      });

      $(".toolbox-reduce").on("click", function () {
        $(".script", _this.$el)
          .closest(".configurable-field-type-script")
          .animate(
            {
              top: "0px",
              left: "0px",
            },
            {
              duration: 500,
              complete: function () {
                $(this).css({
                  position: "relative",
                  zIndex: "0",
                });
              },
            }
          );

        $(".script", _this.$el).animate(
          {
            width: "240px",
            height: "200px",
          },
          {
            duration: 500,
            complete: function () {
              _ed[$(this)[0].id].resize();
            },
          }
        );
        $(".toolbox-reduce", _this.$el).hide();
      });

      $(".toolbox-apply").on("click", function () {
        if (_this.is_wizard) {
          _this.create_operation();
        } else {
          _this.update({
            script: _ed[$(".script", _this.$el)[0].id].getValue(),
          });
        }
      });
    });
  },

  viewer_click: function (pos) {
    this.update(pos);
  },
});

SculpteoOperationUI.FramePlacementOperation = function (
  $el,
  design,
  operation,
  options
) {
  this._super(undefined, $el, design, operation, options);
}.extend(SculpteoOperationUI, {
  bind: function () {
    var _this = this;

    this._super("bind");
    var widget = new MaskPlacement($(".MaskPlacement", this.$el)[0]);

    widget.width = widget.height = $(".MaskPlacement", this.$el).width();
    var mask = $(".MaskPlacement", this.$el).data("widgetArgs").mask,
      frames = $(".MaskPlacement", this.$el).data("widgetArgs").frames,
      maskBg = $(".MaskPlacement", this.$el).data("widgetArgs").maskBg;

    widget.load_frames(frames, mask, maskBg);
    widget.askImage = function (callback) {
      $(".texture-container", _this.$el).slideDown(300, function () {
        _this.media_upload(
          $("[data-selector=texture-add]", _this.$el),
          _this.$el,
          "image"
        );
      });

      _this.$el.off("click", "[data-selector=texture]");
      _this.$el.on("click", "[data-selector=texture]", function () {
        $("[data-selector=texture]", _this.$el).removeClass("selected");
        $(this).addClass("selected");
        callback({ src: $(this).data("src"), id: $(this).data("id") });

        return false;
      });
    };

    widget.imageSelectionDone = function (callback) {
      $(".texture-container", _this.$el).slideUp();
    };

    var update = function () {
      var result = widget.done();
      var args = {};

      for (id_frame in result) {
        var param = "texture" + id_frame,
          param_args = result[id_frame];

        args[param] = param_args.id;
        args[param + ".crop_x"] = param_args.crop_x;
        args[param + ".crop_y"] = param_args.crop_y;
        args[param + ".crop_w"] = param_args.crop_width;
        args[param + ".crop_h"] = param_args.crop_height;
        args[param + ".size_corner_x1"] = param_args.x;
        args[param + ".size_corner_y1"] = param_args.y;
        args[param + ".size_corner_x2"] = param_args.end_x;
        args[param + ".size_corner_y2"] = param_args.end_y;
        args[param + ".size_x"] = param_args.size_x;
        args[param + ".size_y"] = param_args.size_y;
      }

      _this.update(args);
    };

    widget.paramOK = function () {
      update();
    };

    $(".btn-test", this.$el).on("click", function () {
      udpate();

      return false;
    });
  },
});

SculpteoOperationUI.ExtrusionDesignOperation = function (
  $el,
  design,
  operation
) {
  this._super(undefined, $el, design, operation);
  this.current_focus = null;
}.extend(SculpteoOperationUI, {
  set_initial: function (data) {
    var el = this.$el;

    this.$el.data("operation", data);
    $(".DepthInvert", el).attr("checked", data.depth < 0);
    $(".BackgroundSliderControl", el).SliderControl({ value: data.background });
    $(".BackgroundSliderControl .text-value").text(
      (data.background * 10).toFixed(2)
    );
    $(".NumberPixelsSliderControl", el).SliderControl({ value: data.npixels });
    $(".ContrastThresholdAutomatic", el).attr(
      "checked",
      data.contrast_threshold_automatic
    );
    $(".ContrastSliderControl", el)
      .SliderControl({ value: data.contrast_threshold })
      .find(".the-slider")
      .slider("option", "disabled", data.contrast_threshold_automatic);
    $(".DetailThresholdAutomatic", el).attr(
      "checked",
      data.detail_threshold_automatic
    );
    $(".DetailSliderControl", el)
      .SliderControl({ value: data.detail_threshold })
      .find(".the-slider")
      .slider("option", "disabled", data.detail_threshold_automatic);
    $(".UseTexture", el).attr(
      "checked",
      !data.use_new_texture && !data.usecolors
    );
    $(".UseNewTexture", el).attr(
      "checked",
      data.use_new_texture && !data.usecolors
    );
    $(".UseColors", el).attr(
      "checked",
      !data.use_new_texture && data.usecolors
    );
    $(".step1", el).toggle(data.o_image == null);
    $(".step2", el).toggle(data.o_image != null);
    $(".new-texture-pick", el).toggle(data.o_new_texture == null);
    $(".new-texture-parameters", el).toggle(data.o_new_texture != null);

    if (data.o_image != null) {
      $(".OrderButton, .SaveButton").removeClass("disabled");
      this.update_image();
    } else {
      $(".image-src", this.$el).text("");
    }

    this.select_mode(this.$el, data, $.noop);
  },

  select_mode: function ($el, data, cb) {
    $(".select-extrude", $el).removeClass("on");
    $(".select-extrude.extrude" + data.mode, $el).addClass("on");
    var args = { mode: data.mode };

    switch (data.mode) {
      case 0:
      case 5:
        $(".paintmethod, .paintmethod .paintmethod-select", $el).show();
        $(
          ".paintmethod-UseColors .paintmethod-parameters .fg-color",
          $el
        ).show();
        $(
          ".DepthSlider, .BackgroundSliderControl, .ContrastThreshold, .DetailThreshold",
          $el
        ).show();
        $(".NumberPixelsSlider", $el).hide();
        this.select_paint_method_ui($el, data);
        break;
      case 1:
      case 6:
        if (data.use_new_texture) {
          args["use_new_texture"] = false;
          args["o_new_texture"] = null;
          args["usecolors"] = false;
          $(".UseTexture", $el).attr("checked", true);
        }

        this.select_paint_method_ui($el, data);
        $(".paintmethod-UseColors, .paintmethod-UseTexture", $el)
          .show()
          .find(".paintmethod-select")
          .show();
        $(
          ".paintmethod-UseColors .paintmethod-parameters .fg-color",
          $el
        ).show();
        $(".paintmethod-UseNewTexture", $el).hide();
        $(".DepthSlider, .BackgroundSliderControl", $el).show();
        $(
          ".NumberPixelsSlider, .ContrastThreshold, .DetailThreshold",
          $el
        ).hide();
        break;
      case 2:
        $(".paintmethod-UseNewTexture, .paintmethod-UseTexture", $el).hide();
        $(".paintmethod-UseColors", $el)
          .show()
          .find(".paintmethod-select")
          .hide();
        $(
          ".paintmethod-UseColors .paintmethod-parameters .fg-color",
          $el
        ).hide();
        $(".NumberPixelsSlider", $el).show();
        $(
          ".DepthSlider, .BackgroundSliderControl, .ContrastThreshold, .DetailThreshold",
          $el
        ).hide();
        break;
    }
    cb(args);
  },

  select_paint_method_ui: function ($el, data) {
    if (!data.use_new_texture && !data.usecolors) {
      $(".paintmethod-parameters", $el).hide();
    } else if (data.use_new_texture && !data.usecolors) {
      $(".paintmethod-UseColors .paintmethod-parameters", $el).hide();
      $(".paintmethod-UseNewTexture .paintmethod-parameters", $el).show();
    } else if (!data.use_new_texture && data.usecolors) {
      $(".paintmethod-UseColors .paintmethod-parameters", $el).show();
      $(".paintmethod-UseNewTexture .paintmethod-parameters", $el).hide();
    }
  },

  update_image: function () {
    var _this = this;

    if (_this.data("o_image")) {
      $.getJSON(
        URLS["x_design_vectorized_image"],
        {
          contrast_threshold: _this.data("contrast_threshold"),
          contrast_threshold_automatic: _this.data(
            "contrast_threshold_automatic"
          ),
          detail_threshold: _this.data("detail_threshold"),
          detail_threshold_automatic: _this.data("detail_threshold_automatic"),
          o_logo: _this.data("o_image"),
          methodid: _this.data("methodid"),
          mask_id: _this.data("mask"),
          image_x: _this.data("image_x"),
          image_y: _this.data("image_y"),
          image_w: _this.data("image_w"),
          image_h: _this.data("image_h"),
        },
        function (d) {
          $(".vectorized-image", _this.$el).attr("src", d.url);

          if ($(".image-src", _this.$el).text() != d.original) {
            $(".image-src", _this.$el).text(d.original);
            _this.crop_texture(
              $(".Image-pick", _this.$el),
              function (data) {
                _this.update(data);
              },
              "image_"
            );
          }
        }
      );
    }
  },

  crop_texture: function ($el, cb, prefix) {
    var imageSrc = $(".image-src", $el).text(),
      _this = this;

    if (!prefix) {
      prefix = "";
    }

    if (!imageSrc) {
      return;
    }

    var op = getOperation($el);
    var data = _this.$el.data("operation");

    var loader = new ImageLoader(imageSrc);

    loader.loadEvent = function (imageUrl, img) {
      var w = img.width,
        h = img.height;

      if (w > 128 && h <= w) {
        h = (h * 128) / w;
        w = 128;
      } else if (h > 128 && h > w) {
        w = (w * 128) / h;
        h = 128;
      }

      $(".image-content", $el).empty().append(img);
      $(".image-content img", $el)
        .attr({
          width: w,
          height: h,
        })
        .removeClass("crop-img");

      // Test for presence of image-crop. If it's not present, it means the crop field is locked
      if ($(".image-crop", $el).length && $(".image-crop", $el).text() != "") {
        $(".image-content img", $el).Jcrop({
          onSelect: function setCoords(c) {
            args = {};
            args[prefix + "x"] = c.x / w;
            args[prefix + "y"] = c.y / h;
            args[prefix + "w"] = c.w / w;
            args[prefix + "h"] = c.h / h;
            cb(args);
          },

          setSelect: [
            w * parseFloat(data[prefix + "x"]),
            h * parseFloat(data[prefix + "y"]),
            w *
              (parseFloat(data[prefix + "x"]) + parseFloat(data[prefix + "w"])),
            h *
              (parseFloat(data[prefix + "y"]) + parseFloat(data[prefix + "h"])),
          ],
        });
      }
    };

    setTimeout(function () {
      loader.load();
    }, 100);
  },

  bind: function () {
    var _this = this;

    this._super("bind");
    this.update_backup = this.update;

    function my_update(args) {
      var dfd = _this.update_backup(args);

      if ($(".vectorized-image", _this.$el).length) {
        if (
          typeof args["contrast_threshold"] != "undefined" ||
          typeof args["contrast_threshold_automatic"] != "undefined" ||
          typeof args["detail_threshold"] != "undefined" ||
          typeof args["detail_threshold_automatic"] != "undefined" ||
          typeof args["o_image"] != "undefined"
        ) {
          _this.update_image();
        }
      }
      return dfd;
    }

    this.update = my_update;
    var internal_extrusion = {
      step1: function (evt) {
        if (_this.design.get_operation("TextDesignOperation")) {
          $.when(
            _this.design
              .get_operation("TextDesignOperation")
              .modify({ enabled: true }, true)
          ).then(function () {
            my_update({
              o_image: null,
            });
          });
        } else {
          my_update({
            o_image: null,
          });
        }

        $(".OrderButton, .SaveButton").addClass("disabled");
        $(".step1", _this.$el).show();
        $(".step2", _this.$el).hide();

        return false;
      },

      texture_click: function (evt) {
        var texture_id = $(this).data("id");

        if (_this.design.get_operation("TextDesignOperation")) {
          $.when(
            _this.design
              .get_operation("TextDesignOperation")
              .modify({ enabled: false }, true)
          ).then(function () {
            my_update({
              o_image: texture_id,
            });
            _this.$el.trigger($.Event("operation.texture_selected"));
            $(".OrderButton, .SaveButton").removeClass("disabled");
          });
        } else {
          my_update({
            o_image: texture_id,
          });
          _this.$el.trigger($.Event("operation.texture_selected"));
        }

        $(".step1", _this.$el).hide();
        $(".step2", _this.$el).show();

        if ($(this).hasClass("texturetype-bitmap")) {
          $(".BitmapImageOperations", _this.$el).show();
          $(".Image-pick .image-crop", _this.$el).text("1");
        } else {
          $(".BitmapImageOperations", _this.$el).hide();
          $(".Image-pick .image-crop", _this.$el).text("");
        }

        $(".Image-pick .image-src", _this.$el).text($(this).data("src"));
        _this.crop_texture(
          $(".Image-pick", _this.$el),
          function (data) {
            my_update(data);
          },
          "image_"
        );
      },

      new_texture_click: function (evt) {
        var texture_id = $(this).data("id");

        my_update({
          o_new_texture: texture_id,
        });
        $(".new-texture-pick", _this.$el).hide();
        $(".new-texture-parameters", _this.$el).show();
        $(".paintmethod-UseNewTexture .image-src", _this.$el).text(
          $(this).data("src")
        );
        _this.crop_texture(
          $(".paintmethod-UseNewTexture .paintmethod-parameters", _this.$el),
          function (data) {
            my_update(data);
          },
          "new_texture_"
        );
      },

      reset_new_texture: function (evt) {
        my_updates({ o_new_texture: null });
        $(".new-texture-pick", _this.$el).show();
        $(".new-texture-parameters", _this.$el).hide();

        return false;
      },
    };

    $(".DepthSliderControl .the-slider", _this.$el).slider({
      orientation: "horizontal",
      precision: 2,
      min: 0.001,
      max: 0.2,
      step: 0.001,
      slide: function (evt, ui) {
        $(".text-value", $(this).closest(".slider-control")).text(
          (ui.value * 10).toFixed(2)
        );
      },

      change: function (evt, ui) {
        $(".text-value", $(this).closest(".slider-control")).text(
          (ui.value * 10).toFixed(2)
        );
      },

      stop: function (evt, ui) {
        var v = $(".DepthInvert", this.$el).is(":checked")
          ? -Math.abs(ui.value)
          : Math.abs(ui.value);

        my_update({ depth: v });
      },

      value: Math.abs(_this.data("depth")),
    });
    $(".DepthSliderControl .slider-reset", _this.$el).on(
      "click",
      function (evt) {
        my_update({ depth: 0.1 });
        $(".DepthSliderControl .the-slider", _this.$em).slider(
          "option",
          "value",
          0.1
        );
        $(".DepthSliderControl .text-value", _this.$el).text("1");

        return false;
      }
    );

    $(".DepthInvert", _this.$el).click(function (evt) {
      var depth = $(".DepthSliderControl .the-slider", _this.$el).slider(
        "value"
      );

      my_update({ depth: $(this).is(":checked") ? -depth : depth });
    });

    $(".BackgroundSliderControl .the-slider", _this.$el).slider({
      orientation: "horizontal",
      precision: 2,
      min: 0,
      max: 0.1,
      step: 0.001,
      slide: function (evt, ui) {
        $(".text-value", $(this).closest(".slider-control")).text(
          (ui.value * 10).toFixed(2)
        );
      },

      change: function (evt, ui) {
        $(".text-value", $(this).closest(".slider-control")).text(
          (ui.value * 10).toFixed(2)
        );
      },

      stop: function (evt, ui) {
        my_update({ background: ui.value });
      },

      value: _this.data("background"),
    });
    $(".BackgroundSliderControl .slider-reset", _this.$el).on(
      "click",
      function (evt) {
        my_update({ background: 0.05 });
        $(".BackgroundSliderControl .text-value", _this.$el).text("0.5");
        $(".BackgroundSliderControl .the-slider", $div).slider(
          "option",
          "value",
          0.05
        );

        return false;
      }
    );

    $(".ContrastThresholdAutomatic", _this.$el).click(function (evt) {
      $(".ContrastSliderControl .the-slider", _this.$el).slider(
        "option",
        "disabled",
        $(this).is(":checked")
      );
      my_update({ contrast_threshold_automatic: $(this).is(":checked") });
    });

    $(".DetailThresholdAutomatic", _this.$el).click(function (evt) {
      $(".DetailSliderControl .the-slider", _this.$el).slider(
        "option",
        "disabled",
        $(this).is(":checked")
      );
      my_update({ detail_threshold_automatic: $(this).is(":checked") });
    });

    $("input:radio[name=paintmethod]", _this.$el).change(function (evt) {
      var method = $(this).val();

      switch (method) {
        case "UseTexture":
          my_update({ use_new_texture: false, usecolors: false });
          break;
        case "UseNewTexture":
          my_update({ use_new_texture: true, usecolors: false });
          break;
        case "UseColors":
          my_update({ use_new_texture: false, usecolors: true });
          break;
      }
      _this.select_paint_method_ui(_this.$el, _this.$el.data("operation"));
    });

    $(".select-extrude", _this.$el).click(function (evt) {
      var d = _this.$el.data("operation");

      d["mode"] = parseInt(extractIdFromClass($(this), "extrude"));
      _this.select_mode(_this.$el, d, function (data) {
        my_update(data);
      });
    });

    $(".Image-pick", _this.$el).delegate(
      "img",
      "click",
      internal_extrusion.texture_click
    );
    _this.media_upload(
      $(".Image-pick .upload-image", _this.$el),
      $(".Image-pick", _this.$el),
      "image"
    );
    _this.set_initial(_this.$el.data("operation"));

    if (this.data("o_image")) {
      $.getJSON(URLS["x_get_texture"] + this.data("o_image"), function (resp) {
        $(".Image-pick .image-src", _this.$el).text(resp.url);
        _this.crop_texture(
          $(".Image-pick", _this.$el),
          function (data) {
            my_update(data);
          },
          "image_"
        );
      });
    }

    $(".Image-pick .removefile", _this.$el).click(internal_extrusion.step1);

    $(".paintmethod-UseNewTexture .texture-gallery", _this.$el).delegate(
      "img",
      "click",
      internal_extrusion.new_texture_click
    );
    _this.media_upload(
      $(".paintmethod-UseNewTexture", _this.$el),
      $(".paintmethod-UseNewTexture", _this.$el),
      "image"
    );

    if (this.data("o_new_texture") && this.data("use_new_texture")) {
      $.getJSON(
        URLS["x_get_texture"] + this.data("o_new_texture"),
        function (resp) {
          $(".paintmethod-UseNewTexture .image-src", _this.$el).text(resp.url);
          _this.crop_texture(
            $(".paintmethod-UseNewTexture", _this.$el),
            function (data) {
              my_update(data);
            },
            "image_"
          );
        }
      );
    }

    $(".paintmethod-UseNewTexture .removefile", _this.$el).click(
      internal_extrusion.reset_new_texture
    );
  },
});

SculpteoOperationWizardUI = function (design) {
  this.design = design;
  this.current = null;
  this.transition = 300; // Millisecond
  this.defaultWidth = 265;
  this.selected_div = null;
};

SculpteoOperationWizardUI.prototype = {
  ready: function () {
    var _this = this;

    this.menu_slider();
    $.Topic("operation-added").subscribe(function (data) {
      _this.show_creation_hint(data);
    });
  },

  menu_slider: function () {
    var _this = this;

    $("#create-wizard")
      .on("click", "a.wizard-navigation", function (event) {
        event.preventDefault();
        _this.show_target($(this).attr("href"), true);

        return false;
      })
      .on("click", "a.wizard-navigation-back", function (event) {
        return _this.show_start();
      })
      .on("click", "#wizard-configuration-mode-chkbx", function (event) {
        _this.show_start();
      })
      .on("click", "#configuration-mode-chkbx", function (event) {
        _this.selected_div = "#create-wizard-configure";
        var checked = $(this).is(":checked");

        _this.design.fetch_operation().then(function () {
          _this.design.configuration_mode(checked).then(function () {
            $("#create-wizard-configure [name=configure]").attr(
              "checked",
              checked
            );
          });

          _this.design.configuration_preview_mode(false);
        });

        if (!checked) {
          event.stopImmediatePropagation();

          return false;
        }
      });
  },

  resize: function () {
    if (
      $("#create-wizard > div").height() <
      $(this.selected_div).height() + $("#color-warning").height()
    ) {
      $("#create-wizard > div").css(
        "height",
        $(this.selected_div).height() + $("#color-warning").height() + 10
      );
    }
  },

  show_target: function (selector, animated) {
    var parent = $("#create-wizard-start"),
      _this = this;

    // Put div just after the menu, and slide the div
    this.selected_div = selector;
    $(selector).detach().insertAfter(parent);
    $("#create-wizard .slider").animate(
      { marginLeft: -this.defaultWidth },
      animated ? this.transition : 0,
      function () {
        _this.resize();
      }
    );

    this.show_operation_wizard();
  },

  show_start_reverse: function ($el) {
    $el.css({ marginLeft: -530 });
    $("#create-wizard-start")
      .css({ marginLeft: 530 })
      .animate({ marginLeft: 265 }, this.transition, "swing", function () {
        $el.css({ marginLeft: 0 });
        $(this).css({ marginLeft: 0 });
        $("#create-wizard .slider").css({ marginLeft: 0 });
      });

    if (
      $("#create-wizard > div").height() < $("#create-wizard-start").height()
    ) {
      $("#create-wizard > div").css(
        "height",
        $("#create-wizard-start").height()
      );
    }

    if (this.design.material) {
      $("#create-wizard .no-color-warning").toggle();
    }

    this.current = null;

    return false;
  },

  show_start: function () {
    $("#create-wizard .slider").animate({ marginLeft: 0 }, this.transition);

    if (
      $("#create-wizard > div").height() <
      $("#create-wizard-start").height() + $("#color-warning").height() + 10
    ) {
      $("#create-wizard > div").css(
        "height",
        $("#create-wizard-start").height() + $("#color-warning").height() + 10
      );
    }

    if (this.design.material) {
      $(".no-color-warning").toggle();
    }

    this.current = null;

    return false;
  },

  show_operation_wizard: function () {
    if ($(this.selected_div).attr("id") == "create-wizard-configure") {
      this.configure_wizard();
    } else {
      var op_ui = SculpteoOperationUI.from_el(
        $(".SculpteoOperation", $(this.selected_div)),
        this.design
      )
        .wizard(this)
        .show();

      $.Topic("viewer-show-model").publish();
      this.current = op_ui;
    }
  },

  show_success: function ($el) {
    $("#create-wizard-sucess").detach().insertAfter($(this.selected_div));
    $("#create-wizard .slider")
      .animate({ marginLeft: -2 * this.defaultWidth }, this.transition)
      .delay(2000)
      .animate({ marginLeft: 0 }, this.transition);
    this.current = null;
  },

  show_creation_hint: function (data) {
    var top =
      $("[data-opseq=" + data.seq + "]")
        .parent()
        .position().top +
      $("[data-opseq=" + data.seq + "]")
        .parent()
        .parent()
        .position().top -
      14;

    $("#create-wizard-arrow")
      .css("top", 0 + $("#create-wizard-sucess").height() + 20)
      .css("right", -50 - $("#create-wizard-sucess").width() / 2)
      .fadeIn()
      .delay(100)
      .animate({ top: top, right: -70 })
      .delay(500)
      .fadeOut(2000);
  },

  configure_wizard: function () {
    var _this = this;

    $(".wizard-navigation-back", $(this.selected_div)).show();
    $(".configure-wizard-info-title").hide();
    $(".configure-wizard-create-title").show();

    if (!$(this.selected_div).data("binded")) {
      $.when(_this.design.fetch_operation()).then(function () {
        $(".loading", $(_this.selected_div)).hide();
        $(".loaded", $(_this.selected_div)).show();
        $(_this.selected_div).data("binded", true);
        $(_this.selected_div).on("click", "[name=configure]", function () {
          _this.design.configuration_mode($(this).is(":checked"));
          _this.design.configuration_preview_mode(false);
        });
      });
    }
  },
};

function CanvasWidget(container, callback, Kinetic) {
  this.container = container;
  this.callback = callback;
  this.width = 300;
  this.height = 300;
  this.stage = null;
  this.zoom = 1;
  this.Kinetic = Kinetic;
}

CanvasWidget.prototype = {
  information: function (txt) {
    var textLayer = new this.Kinetic.Layer({ name: "textLayer" }),
      textObj = new this.Kinetic.Text({
        x: 0,
        y: 0,
        fontFamily: "monospace",
        text: txt,
        fontSize: 8,
        fill: "#00f903",
      }),
      textObjRect = new this.Kinetic.Rect({
        x: 0,
        y: 0,
        fontFamily: "monospace",
        height: textObj.getHeight(),
        width: textObj.getWidth(),
        fill: "#000",
        stroke: "#000",
        strokeWidth: 2,
        opacity: 0.8,
      }),
      _this = this;

    textLayer.add(textObjRect);
    textLayer.add(textObj);
    this.stage.add(textLayer);
    textLayer.moveToTop();
    textLayer.dispose = function () {
      textLayer.remove(textObj);
      textLayer.destroy();
    };

    return textLayer;
  },

  createStage: function () {
    this.stage = new this.Kinetic.Stage({
      container: this.container,
      width: this.width,
      height: this.height,
    });
    this.box = { x: 0, y: 0, width: this.width, height: this.height };
  },

  resetStage: function () {
    this.stage.removeChildren();
  },

  getOrCreateStage: function () {
    if (this.stage) {
      this.resetStage();
    } else {
      this.createStage();
    }
  },

  create_image_in_box: function (imageObj, box, o) {
    var options = {
      fit_within: true,
      image: null,
    };

    $.extend(options, o);

    var box_ratio = box.width / box.height,
      img_ratio = imageObj.width / imageObj.height;
    var x, y, width, height;

    if (!options.fit_within) {
      if (img_ratio < box_ratio) {
        width = box.width;
        height = box.width / img_ratio;
        x = box.x;
        y = box.y + (box.height - height) / 2;
      } else {
        height = box.height;
        width = box.height * img_ratio;
        x = box.x + (box.width - width) / 2;
        y = box.y;
      }
    } else {
      if (box_ratio > img_ratio) {
        y = box.y;
        height = box.height;
        width = img_ratio * height;
        x = box.x + (box.width - width) / 2;
      } else {
        x = box.x;
        width = box.width;
        height = width / img_ratio;
        y = box.y + (box.height - height) / 2;
      }
    }

    if (options.image) {
      options.image.setImage(imageObj);
      options.image.setX(x);
      options.image.setY(y);
      options.image.setWidth(width);
      options.image.setHeight(height);
      options.image.setScale(1.0, 1.0);
      options.image.aspect_ratio = img_ratio;

      return options.image;
    } else {
      var img = new this.Kinetic.Image({
        x: x,
        y: y,
        image: imageObj,
        width: width,
        height: height,
      });

      img.aspect_ratio = img_ratio;

      return img;
    }
  },

  setPointer: function (active, o) {
    var options = {
      cursor: "pointer",
    };

    $.extend(options, o);

    if (active) {
      this.stage.getContainer().style.cursor = options.cursor;
    } else {
      this.stage.getContainer().style.cursor = "default";
    }
  },

  getCropInformation: function (image, box, additional_crop) {
    var ret = {},
      img_box = {};

    if (image.getX) {
      img_box.x = image.getX();
      img_box.y = image.getY();
      img_box.width = image.getWidth();
      img_box.height = image.getHeight();
    } else {
      img_box = image;
    }

    ret.x = Math.max(0.0, (img_box.x - box.x) / box.width);
    ret.y = Math.max(0.0, (img_box.y - box.y) / box.height);
    ret.crop_x = Math.max(
      0.0,
      (box.x - img_box.x) / (img_box.width * this.zoom)
    );
    ret.crop_y = Math.max(
      0.0,
      (box.y - img_box.y) / (img_box.height * this.zoom)
    );
    var end_x = img_box.x + img_box.width * this.zoom,
      end_y = img_box.y + img_box.height * this.zoom;

    ret.crop_width =
      (Math.min(end_x, box.x + box.width) - Math.max(box.x, img_box.x)) /
      (img_box.width * this.zoom);
    ret.crop_width = Math.min(1.0, ret.crop_width);
    ret.crop_height =
      (Math.min(end_y, box.y + box.height) - Math.max(box.y, img_box.y)) /
      (img_box.height * this.zoom);
    ret.crop_height = Math.min(1.0, ret.crop_height);
    ret.end_x = Math.min(1.0, (end_x - box.x) / box.width);
    ret.end_y = Math.min(1.0, (end_y - box.y) / box.height);

    if (additional_crop) {
      ret.crop_x += ret.crop_x * additional_crop.x;
      ret.crop_y += ret.crop_y * additional_crop.y;
      ret.crop_w -= ret.crop_w * additional_crop.w;
      ret.crop_h -= ret.crop_h * additional_crop.h;
    }

    return ret;
  },
};

function CropImage(container) {
  this.container = container;
  this.offsetX = 10;
  this.offsetY = 10;
  this.stage = null;
}

CropImage.prototype = {
  load: function (imageSrc, callback) {
    var _this = this;

    this.callback = callback;
    this.imageObj = new Image();
    this.imageObj.onload = function () {
      _this.imageLoaded();
    };

    this.imageObj.src = imageSrc;
    this.crop_information = {
      x: 0,
      y: 0,
      w: 1,
      h: 1,
    };
  },

  clear: function () {
    if (this.stage) {
      this.stage.clear();
    }
  },

  imageLoaded: function () {
    var imageObj = this.imageObj,
      _this = this;

    if (this.callback) {
      this.callback();
    }

    if (!this.stage) {
      this.stage = new this.Kinetic.Stage({
        container: this.container,
        width: 300,
        height: 300,
      });
      var stage = this.stage;
      var cropGroup = new this.Kinetic.Group({
        x: 0,
        y: 0,
        draggable: true,
        name: "cropgroup",
      });
      var layer = new this.Kinetic.Layer({ name: "layer" });
      var offsetX = this.offsetX,
        offsetY = this.offsetY,
        w = stage.getWidth() - 2 * offsetX,
        h = stage.getHeight() - 2 * offsetY;
      var img = new this.Kinetic.Image({
        x:
          imageObj.width >= imageObj.height
            ? offsetX
            : offsetX + (w * (1 - imageObj.width / imageObj.height)) / 2,
        y:
          imageObj.height >= imageObj.width
            ? offsetY
            : offsetY + (h * (1 - imageObj.height / imageObj.width)) / 2,
        image: imageObj,
        width:
          imageObj.width >= imageObj.height
            ? w
            : w * (imageObj.width / imageObj.height),
        height:
          imageObj.height >= imageObj.width
            ? h
            : h * (imageObj.height / imageObj.width),
        name: "cropimg",
      });

      this.img = img;
      layer.add(img);
      var cropRect = new this.Kinetic.Rect({
        x: img.getX(),
        y: img.getY(),
        width: img.getWidth(),
        height: img.getHeight(),
        stroke: "#00ff00",
        strokeWidth: 2,
        fill: "rgba(100, 100, 100, 0.5)",
        name: "rect",
      });

      cropGroup.add(cropRect);
      cropGroup.on("dragend", function () {
        _this.update_crop(cropGroup);
      });

      layer.add(cropGroup);
      var bounds = {
        left: this.img.getX(),
        top: this.img.getY(),
        right: this.img.getX() + this.img.getWidth(),
        bottom: this.img.getY() + this.img.getHeight(),
      };

      this.addAnchor(
        cropGroup,
        img.getX(),
        img.getY(),
        "topLeft"
      ).setDragBounds(bounds);
      this.addAnchor(
        cropGroup,
        img.getX() + img.getWidth(),
        img.getY(),
        "topRight"
      ).setDragBounds(bounds);
      this.addAnchor(
        cropGroup,
        img.getX() + img.getWidth(),
        img.getY() + img.getHeight(),
        "bottomRight"
      ).setDragBounds(bounds);
      this.addAnchor(
        cropGroup,
        img.getX(),
        img.getY() + img.getHeight(),
        "bottomLeft"
      ).setDragBounds(bounds);
      stage.add(layer);
    } else {
      this.stage.clear();
      var stage = this.stage;
      var offsetX = this.offsetX,
        offsetY = this.offsetY,
        w = stage.getWidth() - 2 * offsetX,
        h = stage.getHeight() - 2 * offsetY,
        layer = stage.get(".layer")[0],
        img = layer.get(".cropimg")[0],
        cropGroup = layer.get(".cropgroup")[0];

      img.setImage(imageObj);
      img.setX(
        imageObj.width >= imageObj.height
          ? offsetX
          : offsetX + (w * (1 - imageObj.width / imageObj.height)) / 2
      );
      img.setY(
        imageObj.height >= imageObj.width
          ? offsetY
          : offsetY + (h * (1 - imageObj.height / imageObj.width)) / 2
      ),
        img.setWidth(
          imageObj.width >= imageObj.height
            ? w
            : w * (imageObj.width / imageObj.height)
        );
      img.setHeight(
        imageObj.height >= imageObj.width
          ? h
          : h * (imageObj.height / imageObj.width)
      );
      var cropRect = cropGroup.get(".rect")[0];

      cropRect.setX(img.getX());
      cropRect.setY(img.getY());
      cropRect.setWidth(img.getWidth());
      cropRect.setHeight(img.getHeight());
      var bounds = {
        left: img.getX(),
        top: img.getY(),
        right: img.getX() + img.getWidth(),
        bottom: img.getY() + img.getHeight(),
      };
      var topLeft = cropGroup.get(".topLeft")[0],
        topRight = cropGroup.get(".topRight")[0],
        bottomRight = cropGroup.get(".bottomRight")[0],
        bottomLeft = cropGroup.get(".bottomLeft")[0];

      cropGroup.setX(0);
      cropGroup.setY(0);
      topLeft.attrs.x = img.getX();
      topLeft.attrs.y = img.getY();
      topLeft.setDragBounds(bounds);

      topRight.attrs.x = img.getX() + img.getWidth();
      topRight.attrs.y = img.getY();
      topRight.setDragBounds(bounds);

      bottomRight.attrs.x = img.getX() + img.getWidth();
      bottomRight.attrs.y = img.getY() + img.getHeight();
      bottomRight.setDragBounds(bounds);

      bottomLeft.attrs.x = img.getX();
      bottomLeft.attrs.y = img.getY() + img.getHeight();
      bottomLeft.setDragBounds(bounds);
      this.stage.draw();
    }
  },

  update: function (group, activeAnchor) {
    var topLeft = group.get(".topLeft")[0];
    var topRight = group.get(".topRight")[0];
    var bottomRight = group.get(".bottomRight")[0];
    var bottomLeft = group.get(".bottomLeft")[0];
    var rect = group.get(".rect")[0];

    // Update anchor positions
    switch (activeAnchor.getName()) {
      case "topLeft":
        topRight.attrs.y = activeAnchor.attrs.y;
        bottomLeft.attrs.x = activeAnchor.attrs.x;
        break;
      case "topRight":
        topLeft.attrs.y = activeAnchor.attrs.y;
        bottomRight.attrs.x = activeAnchor.attrs.x;
        break;
      case "bottomRight":
        bottomLeft.attrs.y = activeAnchor.attrs.y;
        topRight.attrs.x = activeAnchor.attrs.x;
        break;
      case "bottomLeft":
        bottomRight.attrs.y = activeAnchor.attrs.y;
        topLeft.attrs.x = activeAnchor.attrs.x;
        break;
    }

    rect.setPosition(topLeft.attrs.x, topLeft.attrs.y);
    var width = topRight.attrs.x - topLeft.attrs.x;
    var height = bottomLeft.attrs.y - topLeft.attrs.y;

    if (width && height) {
      rect.setSize(width, height);
    }
  },

  update_crop: function (group) {
    var topLeft = group.get(".topLeft")[0],
      bottomRight = group.get(".bottomRight")[0];

    this.crop_information = {
      x:
        (group.getX() + topLeft.getX() - this.img.getX()) / this.img.getWidth(),
      y:
        (group.getY() + topLeft.getY() - this.img.getY()) /
        this.img.getHeight(),
      w: (bottomRight.getX() - topLeft.getX()) / this.img.getWidth(),
      h: (bottomRight.getY() - topLeft.getY()) / this.img.getHeight(),
    };
  },

  addAnchor: function (group, x, y, name) {
    var stage = group.getStage();
    var layer = group.getLayer();
    var _this = this;
    var anchor = new this.Kinetic.Circle({
      x: x,
      y: y,
      stroke: "#000",
      fill: "#ff0000",
      strokeWidth: 2,
      radius: 8,
      name: name,
      draggable: true,
    });

    anchor.on("dragmove", function () {
      _this.update(group, this);
      layer.draw();
    });

    anchor.on("mousedown touchstart", function () {
      group.setDraggable(false);
    });

    anchor.on("dragend", function () {
      group.setDraggable(true);
      layer.draw();
    });

    // Add hover styling
    anchor.on("mouseover", function () {
      var layer = this.getLayer();

      document.body.style.cursor = "pointer";
      this.setStrokeWidth(4);
      layer.draw();
    });

    anchor.on("mouseout", function () {
      var layer = this.getLayer();

      document.body.style.cursor = "default";
      this.setStrokeWidth(2);
      layer.draw();
    });

    group.add(anchor);

    return anchor;
  },
};

var FaceProfile = function (container, o, Kinetic) {
  this._super(undefined, container, o, Kinetic);
  this.options = {
    with_bg_color: false,
    transparent_template: false,
  };
  $.extend(this.options, o);
  this.container = container;
  this.stage = null;
  this.profileLine = null;
  this.img = null;
  this.points_slice = [];
  this.profile_edition_timer = false;
  this.is_done = false;
  this.width = 300;
  this.height = 300;
}.extend(CanvasWidget, {
  load: function (data) {
    var _this = this;

    if (!this.stage) {
      this.create_stage();
    }

    var imageObj = new Image();

    imageObj.onload = function () {
      _this.imageLoaded(imageObj, data);
    };

    imageObj.src = data.original;
  },

  create_stage: function () {
    this.stage = new this.Kinetic.Stage({
      container: this.container,
      width: this.width,
      height: this.height,
    });

    (this.bgLayer = new this.Kinetic.Layer()),
      (this.editionLayer = new this.Kinetic.Layer()),
      this.stage.add(this.bgLayer);
    this.stage.add(this.editionLayer);
  },

  imageLoaded: function (imageObj, data) {
    var _this = this;

    this.bgLayer.removeChildren();
    this.editionLayer.removeChildren();

    var image_width,
      image_height,
      w = this.stage.getWidth(),
      h = this.stage.getHeight();

    if (imageObj.width >= imageObj.height) {
      image_width = w;
      image_height = (imageObj.height * w) / imageObj.width;
    } else {
      image_height = h;
      image_width = (imageObj.width * h) / imageObj.height;
    }

    this.img = new this.Kinetic.Image({
      name: "profileimg",
      x: (w - image_width) / 2,
      y: (h - image_height) / 2,
      width: image_width,
      height: image_height,
      image: imageObj,
    });
    this.bgLayer.add(this.img);
    this.points = new Array();
    var cur_y = this.img.getY() + data.first * image_height,
      start_y = cur_y,
      x_start = this.img.getX();

    this.delta_y = image_height / imageObj.height;

    for (i = 0; i < data.profile.length; i++) {
      var x = x_start + data.profile[i] * this.img.getWidth();

      cur_y = start_y + i * this.delta_y;
      this.points.push({ x: x, y: cur_y });
    }

    var end_y = cur_y;

    this.create_profile_line();
    this.create_bounds(start_y, end_y);
    this.stage.draw();
    this.moving = this.limiting = false;
    this.aspectratio = data.aspectratio;
  },

  startLineEdition: function () {
    var _this = this;

    if (!this.profile_edition_timer) {
      this.profile_edition_timer = setInterval(function () {
        _this.update_line_at_mouse();
      }, 100);
    }
  },

  stopLineEdition: function () {
    if (this.profile_edition_timer) {
      clearInterval(this.profile_edition_timer);
      this.profile_edition_timer = null;
    }
  },

  update_line_at_mouse: function () {
    var pos = this.stage.getPointerPosition(),
      slice = this.get_slice(pos),
      middle = slice.length / 2.0,
      diff_x = pos.x - slice[parseInt(middle)].x;

    for (i = 0; i < slice.length; i++) {
      // Slice[i].x += Math.sqrt( middle*middle - (i-middle)*(i-middle)) * 0.1 * slice.direction;
      // slice[i].x += Math.exp( -(middle - i)*(middle - i)*0.001 )  * slice.direction;
      slice[i].x +=
        (pos.x - slice[i].x) *
        Math.exp(
          (-(i - middle) * (i - middle)) /
            (0.0007 * this.points.length * this.points.length)
        );
    }

    this.profileLine.setPoints(this.points);
    this.editionLayer.draw();
  },

  create_profile_line: function (layer, stage) {
    var _this = this;

    this.profileLine = new this.Kinetic.Line({
      points: this.points,
      stroke: "#00FF00",
      strokeWidth: 3,
      opacity: 0.7,
      lineCap: "round",
      lineJoin: "round",
    });
    this.editionLayer.add(this.profileLine);
    this.editionRect = new this.Kinetic.Rect({
      opacity: 0,
      x: 8,
      y: this.points[0].y,
      width: this.stage.getWidth() - 16,
      height: this.points[this.points.length - 1].y - this.points[0].y,
    });
    this.editionLayer.add(this.editionRect);
    this.editionRect.on("mousedown touchstart", function () {
      _this.startLineEdition();
    });

    this.editionRect.on("mouseup touchend mouseout", function () {
      _this.stopLineEdition();
    });

    this.editionRect.on("mouseover", function () {
      _this.stage.getContainer().style.cursor = "pointer";
    });

    this.editionRect.on("mouseout", function () {
      _this.stage.getContainer().style.cursor = "default";
    });
  },

  get_slice: function (pos) {
    var point_idx = parseInt(
      (this.points.length * (pos.y - this.points[0].y)) /
        (this.points[this.points.length - 1].y - this.points[0].y)
    );

    point_idx = Math.min(Math.max(0, point_idx), this.points.length - 1);
    var span = parseInt(this.points.length * 0.2);
    var start_idx = Math.min(
        this.points.length - 1,
        Math.max(0, point_idx - span)
      ),
      end_idx = Math.max(0, Math.min(this.points.length - 1, point_idx + span));
    var s = this.points.slice(start_idx, end_idx);
    var i = 0;

    if (start_idx == 0) {
      var i = 0;

      while (s.length != 2 * span) {
        // Add mirror inversed points
        // add at the beginning
        i++;
        s.unshift({
          x: s[0].x - (s[i].x - s[0].x),
          y: s[0].y - (s[i].y - s[0].y),
        });
      }
    } else {
      var i = s.length - 1,
        i_start = i;

      while (s.length != 2 * span) {
        // Add mirror inversed points
        // add at the beginning
        i--;
        s.push({
          x: s[i_start].x - (s[i].x - s[i_start].x),
          y: s[i_start].y - (s[i].y - s[i_start].y),
        });
      }
    }

    s.span = span;

    return s;
  },

  create_bounds: function (start_y, end_y) {
    var group = new this.Kinetic.Group({
      x: 0,
      y: 0,
      draggable: false,
    });
    var img = this.img;
    var eyebrow = new this.Kinetic.Rect({
      x: img.getX(),
      y: img.getY(),
      width: img.getWidth(),
      height: start_y - img.getY(),
      strokeWidth: 0,
      fill: "rgba(100, 100, 100, 0.5)",
      name: "eyebrow",
    });
    var eyebrowText = new this.Kinetic.Text({
      x: img.getX() + 10,
      y: start_y > 12 ? start_y - 10 : start_y + 4,
      text: gettext("Set this line at the beginning of the hair"),
      fontSize: 6,
      fill: "black",
      fontFamily: "Monospace",
      name: "eyebrowtext",
    });
    var chin = new this.Kinetic.Rect({
      x: img.getX(),
      y: end_y,
      width: img.getWidth(),
      height: img.getY() + img.getHeight() - end_y,
      strokeWidth: 0,
      fill: "rgba(100, 100, 100, 0.5)",
      name: "chin",
      draggable: false,
    });
    var chinText = new this.Kinetic.Text({
      x: img.getX() + 10,
      y: chin.getHeight() > 12 ? end_y + 4 : end_y - 12,
      text: gettext("Set this line at chin bottom"),
      fontSize: 6,
      fill: "black",
      fontFamily: "Monospace",
      name: "chintext",
    });

    group.add(eyebrow);
    group.add(eyebrowText);
    group.add(chin);
    group.add(chinText);
    this.addBoundAnchor(group, img.getX(), start_y, "topLeft");
    this.addBoundAnchor(group, img.getX(), end_y, "bottomLeft");
    this.editionLayer.add(group);
  },

  addBoundAnchor: function (group, x, y, name) {
    var _this = this;
    var anchor = new this.Kinetic.Circle({
      x: x,
      y: y,
      stroke: "#666",
      fill: "#ddd",
      strokeWidth: 2,
      radius: 6,
      name: name,
      draggable: true,
      dragBoundFunc: function (pos) {
        return {
          x: this.getAbsolutePosition().x,
          y: pos.y,
        };
      },
    });

    anchor.on("dragmove", function (evt) {
      evt.cancelBubble = true;
      _this.update_bounds(group, this);
    });

    anchor.on("mousedown touchstart", function (evt) {
      _this.moving = false;
      _this.limiting = true;
      evt.cancelBubble = true;
    });

    anchor.on("dragend", function () {
      _this.limiting = false;
    });

    // Add hover styling
    anchor.on("mouseover", function () {
      var layer = this.getLayer();

      _this.limiting = true;
      document.body.style.cursor = "pointer";
      this.setStrokeWidth(4);
      layer.draw();
    });

    anchor.on("mouseout", function () {
      var layer = this.getLayer();

      _this.limiting = false;
      document.body.style.cursor = "default";
      this.setStrokeWidth(1);
      layer.draw();
    });

    this.editionLayer.add(anchor);
  },

  update_bounds: function (group, activeAnchor) {
    var img = this.img;

    // Update anchor positions
    var do_profile_line_update = false;
    var eyebrow = group.get(".eyebrow")[0];
    var chin = group.get(".chin")[0];

    switch (activeAnchor.getName()) {
      case "topLeft":
        eyebrow.setHeight(activeAnchor.attrs.y - img.getY());
        this.editionRect.setY(activeAnchor.attrs.y);
        this.editionRect.setHeight(chin.attrs.y - eyebrow.getHeight());
        group
          .get(".eyebrowtext")[0]
          .setY(
            eyebrow.getHeight() > 12
              ? activeAnchor.getY() - 10
              : activeAnchor.getY() + 4
          );

        // Add missing points
        while (this.points[0].y + 1.5 * this.delta_y > activeAnchor.attrs.y) {
          this.points.unshift({
            x: this.points[0].x,
            y: this.points[0].y - this.delta_y,
          });
          do_profile_line_update = true;
        }

        break;
      case "bottomLeft":
        chin.setY(activeAnchor.attrs.y);
        chin.setHeight(img.getY() + img.getHeight() - activeAnchor.getY());
        this.editionRect.setHeight(chin.attrs.y - eyebrow.getHeight());
        group
          .get(".chintext")[0]
          .setY(
            chin.getHeight() > 12
              ? activeAnchor.getY() + 4
              : activeAnchor.getY() - 12
          );

        while (
          this.points[this.points.length - 1].y - 2 * 2 * this.delta_y <
          activeAnchor.attrs.y
        ) {
          this.points.push({
            x: this.points[this.points.length - 1].x,
            y: this.points[this.points.length - 1].y + this.delta_y,
          });
          do_profile_line_update = true;
        }

        break;
    }

    if (do_profile_line_update) {
      this.profileLine.setPoints(this.points);
      this.profileLine.getLayer().draw();
    }
  },

  done: function () {
    var width = this.img.getWidth(),
      start_x = this.img.getX(),
      top = this.stage.get(".topLeft")[0].getY(),
      bottom = this.stage.get(".bottomLeft")[0].getY();
    var aspectRatio = this.aspectratio;
    var data = { profile: [] };

    for (i in this.points) {
      var p = this.points[i];

      if (p.y >= top && p.y <= bottom) {
        data["profile"].push((p.x - start_x) / width);
      }
    }

    aspectRatio *= this.points.length / data["profile"].length;
    data["aspectratio"] = aspectRatio;
    this.is_done = true;

    return data;
  },
});

function BubbleCanvas(container, Kinetic) {
  this.container = container;
  this.stage = null;
  this.nb_lines = 20;
  this.resolution = 100;
  this.active_anchor = null;
  this.grow_interval_start = null;
  this.grow_interval = null;
  this.max_val = 10.0;
  this.speed = 0.1;
  this.mask = STATIC_URL + "images/designer-product/iphone-mask.png";
  this.is_done = false;
  this.Kinetic = Kinetic;
}

BubbleCanvas.prototype = {
  setBackground: function (bgUrl) {
    this.mask = bgUrl;
  },

  clear: function () {
    if (this.stage) {
      this.stage.clear();
    }
  },

  load: function () {
    var imageObj = new Image(),
      _this = this;

    imageObj.onload = function () {
      _this.init(imageObj);
    };

    imageObj.src = this.mask;
  },

  init: function (imageObj) {
    var _this = this;
    var img_ratio = imageObj.width / imageObj.height;
    var h = 340;

    if (this.stage) {
      this.stage.clear();
    } else {
      this.stage = new this.Kinetic.Stage({
        container: this.container,
        width: h * img_ratio,
        height: h,
      });
    }

    var stage = this.stage;
    var lineGroup = new this.Kinetic.Group({ x: 0, y: 0 }),
      bubbleGroup = new this.Kinetic.Group({ x: 0, y: 0 });
    var bgLayer = new this.Kinetic.Layer(),
      layer = new this.Kinetic.Layer(),
      bubbleLayer = new this.Kinetic.Layer();
    var w = stage.getWidth(),
      h = stage.getHeight();

    this.sigma_x = Math.min(w, h) / 20.0;
    this.sigma_y = this.sigma_x;
    this.K = Math.min(w, h) / 600.0;
    layer.add(lineGroup);
    bubbleLayer.add(bubbleGroup);
    stage.add(bgLayer);
    stage.add(layer);
    stage.add(bubbleLayer);
    this.create_line_group(lineGroup);
    this.create_bubble_group(bubbleGroup);

    var img = new this.Kinetic.Image({
      x: 0,
      y: 0,
      image: imageObj,
      width: stage.getWidth(),
      height: stage.getHeight(),
    });

    bgLayer.add(img);
    bgLayer.draw();
    this.anim = new this.Kinetic.Animation(function () {
      _this.update();
    }, layer);

    _this.update();
    stage.draw();
    this.demo_mode_start(bubbleGroup);
  },

  demo_mode_start: function (bubbleGroup) {
    var w = this.stage.getWidth(),
      h = this.stage.getHeight(),
      _this = this;

    this.demoText = new this.Kinetic.Text({
      x: w / 2 - 90,
      y: h / 4,
      text: "Demo",
      fontSize: 16,
      fill: "#fff",
      width: 180,
      padding: 20,
      align: "center",
    });
    this.demoTextRect = new this.Kinetic.Rect({
      x: w / 2 - 90,
      y: h / 4,
      fill: "#000",
      stroke: "#555",
      strokeWidth: 5,
      cornerRadius: 10,
      width: 180,
      height: this.demoText.getHeight(),
      opacity: 0.8,
    });
    this.demoStop = new this.Kinetic.Text({
      x: w / 2 - 60,
      y: h / 3 + 30,
      text: "Stop",
      fontSize: 12,
      fill: "white",
      width: 120,
      padding: 20,
      align: "center",
    });
    this.demoStopRect = new this.Kinetic.Rect({
      x: w / 2 - 60,
      y: h / 3 + 30,
      fill: "#f00",
      stroke: "#fff",
      strokeWidth: 5,
      cornerRadius: 10,
      width: 120,
      height: this.demoStop.getHeight(),
    });

    this.demoStop.on("click", function (evt) {
      evt.cancelBubble = true;
      _this.demo_mode_stop();
    });

    bubbleGroup.getLayer().add(this.demoTextRect);
    bubbleGroup.getLayer().add(this.demoStopRect);
    bubbleGroup.getLayer().add(this.demoText);
    bubbleGroup.getLayer().add(this.demoStop);

    this.start_refresh();
    this.demo_anchors = [];
    this.demo_anchors_timeout = [];

    for (i = 0; i < 7; i++) {
      this.demo_anchors_timeout.push(
        setTimeout(function () {
          var r1 = Math.random(),
            r2 = Math.random();
          var added_anchor = _this.addAnchor(bubbleGroup, w * r1, h * r2);

          added_anchor.grow_value = Math.random() * _this.speed;
          _this.demo_anchors.push(added_anchor);
          _this.stage.draw();
        }, i * 400)
      );
    }

    var demo_timeout = 70;

    this.demo_interval = setInterval(function () {
      for (a in _this.demo_anchors) {
        var demo_anchor = _this.demo_anchors[a];

        demo_anchor.value += demo_anchor.grow_value;
      }

      demo_timeout--;
      _this.demoText.setText("Demo (" + parseInt(demo_timeout / 10) + "s)");
      _this.demoText.getLayer().draw();

      if (demo_timeout == 0) {
        _this.demo_mode_stop();
      }
    }, 100);
  },

  demo_mode_stop: function () {
    clearInterval(this.demo_interval);

    for (i in this.demo_anchors_timeout) {
      clearTimeout(this.demo_anchors_timeout[i]);
    }

    for (i in this.demo_anchors) {
      this.demo_anchors[i]._remove();
    }

    this.demoStop.hide();
    this.demoText.hide();
    this.demoStopRect.hide();
    this.demoTextRect.hide();
    this.stop_refresh();
    this.stage.draw();
  },

  start_refresh: function () {
    this.anim.start();
  },

  stop_refresh: function () {
    this.anim.stop();
  },

  start_grow: function (anchor) {
    var _this = this;

    if (!this.grow_interval && !this.grow_interval_start) {
      this.grow_interval_start = setTimeout(function () {
        _this.grow_interval = setInterval(function () {
          if (anchor.value < _this.max_val) {
            anchor.value += _this.speed;
          }
        }, 100);
      }, 300);
    }
  },

  stop_grow: function () {
    if (this.grow_interval_start) {
      clearTimeout(this.grow_interval_start);
      this.grow_interval_start = null;
    }

    if (this.grow_interval) {
      clearInterval(this.grow_interval);
      this.grow_interval = null;
    }
  },

  create_line_group: function (group) {
    var stage = group.getLayer().getStage(),
      w = stage.getWidth() * 1.0,
      h = stage.getHeight() * 1.0,
      _this = this;

    this.lines = new Array();

    for (i = 0; i < this.nb_lines; i++) {
      var line = new this.Kinetic.Line({
        stroke: "#000000",
        strokeWidth: 2,
        lineCap: "round",
        lineJoin: "round",
      });

      this.lines.push(line);
      group.add(line);
    }

    this.lineLayer = group.getLayer();
  },

  create_bubble_group: function (group) {
    var stage = group.getStage(),
      w = stage.getWidth(),
      h = stage.getHeight(),
      _this = this;
    var rect = new this.Kinetic.Rect({
      x: 0,
      y: 0,
      width: w,
      height: h,
      alpha: 0,
    });

    group.add(rect);
    this.bubbles = new Array();
    stage.on("click tap", function (evt) {
      if (!_this.active_anchor) {
        var pos = stage.getPointerPosition(evt);

        _this.addAnchor(group, pos.x, pos.y);
        _this.update();
        stage.draw();
      }
    });

    this.addAnchor(group, w / 2, h / 2);
  },

  addAnchor: function (group, x, y) {
    var layer = group.getLayer();
    var _this = this;

    var anchor = new this.Kinetic.Circle({
      x: x,
      y: y,
      stroke: "#000",
      fill: "#ff0000",
      strokeWidth: 2,
      radius: 5,
      draggable: true,
    });

    anchor._remove = function () {
      var idx = _this.bubbles.indexOf(anchor);

      if (idx != -1) {
        _this.bubbles.splice(idx, 1);
      }

      anchor.hide();
    };

    anchor.on("dblclick dbltap", function (evt) {
      evt.cancelBubble = true;
      anchor._remove();
      layer.draw();
      _this.lineLayer.draw();
    });

    anchor.on("mousedown touchstart", function (evt) {
      _this.moving = false;
      _this.limiting = true;
      _this.active_anchor = anchor;
      evt.cancelBubble = true;
      _this.start_refresh();
      _this.start_grow(this);
    });

    anchor.on("mousemove touchmove", function () {
      _this.stop_grow();
    });

    anchor.on("mouseup dragend", function (evt) {
      _this.limiting = false;
      _this.active_anchor = null;
      evt.cancelBubble = true;
      _this.stop_refresh();
      _this.stop_grow();
    });

    // Add hover styling
    anchor.on("mouseover", function () {
      var layer = this.getLayer();

      _this.limiting = true;
      document.body.style.cursor = "pointer";
      this.setStrokeWidth(3);
      layer.draw();
    });

    anchor.on("mouseout", function () {
      var layer = this.getLayer();

      _this.limiting = false;
      document.body.style.cursor = "default";
      this.setStrokeWidth(1);
      layer.draw();
    });

    anchor.value = 0.5;
    this.bubbles.push(anchor);
    group.add(anchor);

    return anchor;
  },

  update: function (layer) {
    var stage = this.lineLayer.getStage(),
      h = stage.getHeight(),
      w = stage.getWidth();
    var _lines = this.compute_lines();

    for (i = 0; i < this.nb_lines; i++) {
      var line = _lines[i],
        myline = this.lines[i];

      var posx = ((i + 1) * w) / (this.nb_lines + 1);
      var points = new Array();

      for (j = 0; j <= this.resolution; j++) {
        var posy = (j * h) / this.resolution;

        delta = line[j] * w;
        points.push({ x: posx + delta, y: posy });
      }

      myline.setPoints(points);
    }
  },

  compute_lines: function () {
    var _lines = new Array(),
      h = this.stage.getHeight(),
      w = this.stage.getWidth();

    for (i = 0; i < this.nb_lines; i++) {
      var posx = ((i + 1) * w) / (this.nb_lines + 1),
        delta;
      var line = new Array();

      for (j = 0; j <= this.resolution; j++) {
        var posy = (j * h) / this.resolution;

        delta = this.displacement({ x: posx, y: posy });
        line.push(delta);
      }

      _lines.push(line);
    }

    return _lines;
  },

  displacement: function (at) {
    var disp = 0.0,
      invsx2 = 1.0 / (this.sigma_x * this.sigma_x),
      invsy2 = 1.0 / (this.sigma_y * this.sigma_y);

    for (bi in this.bubbles) {
      var bp = this.bubbles[bi],
        pt = { x: bp.getX(), y: bp.getY() },
        val = bp.value,
        dx = (at.x - pt.x) / val,
        dy = (at.y - pt.y) / val,
        d = dx * dx * invsx2 + dy * dy * invsy2,
        i = Math.exp(-0.5 * d);

      disp += i * dx * val;
    }

    return this.K * invsx2 * disp;
  },

  done: function () {
    this.is_done = true;

    return JSON.stringify(this.compute_lines());
  },
};

var PlaceImage = function (container, o, Kinetic) {
  this._super(undefined, container, o, Kinetic);
  this.width = 250;
  this.height = 250;
  this.options = {
    with_bg_color: false,
    transparent_template: false,
  };
  $.extend(this.options, o);
  this.offsetTop = 30;
  this.offsetBottom = 10;
  this.offsetX = 10;
  this.image = null;
  this.bgImageSrc = null;
  this.bgLoading = { loading: true, cb: null };
  this.bgImg = null;
  this.bg_color = { r: 1.0, g: 1.0, b: 1.0 };
  this.event_listeners = {};
  this.is_done = false;
}.extend(CanvasWidget, {
  loadBackground: function (imageSrc, opts) {
    var _this = this;

    this.getOrCreateStage();

    if (this.bgImageSrc != imageSrc) {
      this.bgLoading.loading = true;
      _this.uberLayer.removeChildren();
      this.bgImageSrc = imageSrc;
      var info = this.information(gettext("Loading scene...")),
        bgImageObj = new Image();

      bgImageObj.onload = function () {
        _this.bgImage = _this.create_image_in_box(bgImageObj, _this.box, {
          image: _this.bgImage,
        });

        if (_this.options.transparent_template) {
          _this.bgImage.createImageHitRegion(function () {
            // _this.bgLayer.drawBuffer();
          });
        }

        _this.bgLayer.add(_this.bgImage);
        _this.bgLoading.loading = false;

        if (_this.bgLoading.cb) {
          _this.bgLoading.cb();
          _this.bgLoading.cb = null;
        }

        _this.add_alpha_rect();
        _this.create_zoom();
        info.dispose();
      };

      bgImageObj.src = imageSrc;
    }

    return this;
  },

  setBackgroundColor: function (color, r, g, b) {
    this.bg_color = { r: r, g: g, b: b };
    this.imgBackground.setFill(color);
    this.imgLayer.draw();
    this.post_event("update_region", this.done());
  },

  getImageDimensions: function () {
    return {
      width: this.image.attrs.image.width,
      height: this.image.attrs.image.height,
    };
  },

  loadImage: function (imageSrc, cb) {
    var _this = this;

    if (this.bgLoading.loading) {
      this.bgLoading.cb = function () {
        _this.loadImage(imageSrc, cb);
      };

      return;
    }

    this.getOrCreateStage();
    var _this = this,
      info = _this.information(gettext("Loading image..."));
    var imageObj = new Image();

    imageObj.onload = function () {
      var doBind = _this.image == null;

      _this.image = _this.create_image_in_box(
        imageObj,
        {
          x: _this.bgImage.getX(),
          y: _this.bgImage.getY(),
          width: _this.bgImage.getWidth(),
          height: _this.bgImage.getHeight(),
        },
        { image: _this.image, fit_within: false }
      );

      if (doBind) {
        _this.image.setDraggable(true);
        _this.image.on("mouseover", function () {
          _this.setPointer(true);
        });

        _this.image.on("mouseout", function () {
          _this.setPointer(false);
        });

        _this.image.on("dragstart", function () {
          // Store image information to rollback invalid user changes
          _this.image.dragStart = {
            x: _this.image.getX(),
            y: _this.image.getY(),
            width: _this.image.getWidth(),
            height: _this.image.getHeight(),
          };
        });

        _this.image.on("dragend", function () {
          var ret = _this.getCropInformation(_this.image, {
            x: _this.bgImage.getX(),
            y: _this.bgImage.getY(),
            width: _this.bgImage.getWidth(),
            height: _this.bgImage.getHeight(),
          });

          if (ret.crop_width <= 0.0 || ret.crop_height <= 0.0) {
            // Prevent dragging image out of background
            _this.image.setX(_this.image.dragStart.x);
            _this.image.setY(_this.image.dragStart.y);
            _this.image.setWidth(_this.image.dragStart.width);
            _this.image.setHeight(_this.image.dragStart.height);
            _this.imgLayer.draw();

            return false;
          }

          _this.post_event("update_region", _this.done());
        });

        if (_this.options.with_bg_color) {
          _this.imgBackground = new _this.Kinetic.Rect({
            x: 0,
            y: 0,
            width: _this.stage.getWidth(),
            height: _this.stage.getHeight(),
            fill: "#ffffff",
          });
          _this.imgLayer.add(_this.imgBackground);
        }

        _this.imgLayer.add(_this.image);
      }

      if (_this.bgImageSrc.indexOf("phone_nokia_lumia820") != -1) {
        _this.update_zoom(-24);
      }

      info.dispose();
      _this.stage.draw();

      if (cb) {
        cb();
      }

      _this.post_event("update_region", _this.done());
    };

    imageObj.src = imageSrc;
    this.zoom = 1;
    this.zoom_interval = null;

    return this;
  },

  resetStage: function () {},

  createStage: function () {
    this._super("createStage");
    this.box = {
      x: this.offsetX,
      y: this.offsetTop,
      width: this.stage.getWidth() - 2 * this.offsetX,
      height: this.stage.getHeight() - this.offsetTop - this.offsetBottom,
    };
    log("create stage");
    this.bgLayer = new this.Kinetic.Layer();
    this.uberLayer = new this.Kinetic.Layer();

    if (this.options.transparent_template) {
      this.imgLayer = new this.Kinetic.Layer();
      this.stage.add(this.imgLayer);
      this.stage.add(this.bgLayer);
    } else {
      this.imgLayer = new this.Kinetic.Layer({ opacity: 0.7 });
      this.stage.add(this.bgLayer);
      this.stage.add(this.imgLayer);
    }

    this.stage.add(this.uberLayer);
  },

  start_zoom: function (dir) {
    var _this = this;

    if (!this.zoom_interval) {
      this.zoom_interval = setInterval(function () {
        _this.update_zoom(dir);
      }, 100);
    }
  },

  stop_zoom: function () {
    if (this.zoom_interval) {
      clearInterval(this.zoom_interval);
      this.zoom_interval = null;
      this.post_event("update_region", this.done());
    }
  },

  update_zoom: function (dir) {
    var old_zoom = this.zoom;
    var old_width = old_zoom * this.image.getWidth();
    var old_height = old_zoom * this.image.getHeight();
    var old_x = this.image.getX();
    var old_y = this.image.getY();

    this.zoom += (dir * this.zoom) / 40;

    this.image.setScale(this.zoom, this.zoom);

    var new_width = this.zoom * this.image.getWidth();
    var new_height = this.zoom * this.image.getHeight();

    this.image.setX(this.image.getX() + (old_width - new_width) / 2);
    this.image.setY(this.image.getY() + (old_height - new_height) / 2);

    // Validate
    var ret = this.getCropInformation(this.image, {
      x: this.bgImage.getX(),
      y: this.bgImage.getY(),
      width: this.bgImage.getWidth(),
      height: this.bgImage.getHeight(),
    });

    if (ret.crop_width * new_width < 1 || ret.crop_height * new_height < 1) {
      // Revert
      this.zoom = old_zoom;
      this.image.setScale(this.zoom, this.zoom);
      this.image.setX(old_x);
      this.image.setY(old_y);

      // Return;
    }

    this.imgLayer.draw();
  },

  add_alpha_rect: function () {
    var leftRect = new this.Kinetic.Rect({
      x: 0,
      y: 0,
      width: this.bgImage.getX(),
      height: this.height,
      fill: "rgba(255, 255, 255, 0.9)",
    });
    var rightRect = new this.Kinetic.Rect({
      x: this.bgImage.getX() + this.bgImage.getWidth(),
      y: 0,
      width: this.width - (this.bgImage.getX() + this.bgImage.getWidth()),
      height: this.height,
      fill: "rgba(255, 255, 255, 0.9)",
    });
    var topRect = new this.Kinetic.Rect({
      x: leftRect.getWidth(),
      y: 0,
      width: this.width - 2 * leftRect.getWidth(),
      height: this.bgImage.getY(),
      fill: "rgba(255, 255, 255, 0.9)",
    });
    var bottomRect = new this.Kinetic.Rect({
      x: leftRect.getWidth(),
      y: this.bgImage.getY() + this.bgImage.getHeight(),
      width: this.width - 2 * leftRect.getWidth(),
      height: this.height - (this.bgImage.getY() + this.bgImage.getHeight()),
      fill: "rgba(255, 255, 255, 0.9)",
    });

    this.uberLayer.add(leftRect);
    this.uberLayer.add(rightRect);
    this.uberLayer.add(topRect);
    this.uberLayer.add(bottomRect);
  },

  create_zoom: function () {
    var _this = this;
    var zoomText = new this.Kinetic.Text({
      x: this.width / 2 - 30,
      y: this.offsetTop / 2 - 5,
      text: "Zoom",
      height: 16,
      fontSize: 10,
      fontFamily: "Monospace",
      fill: "#555",
      width: 40,
    });

    this.uberLayer.add(zoomText);
    var minusGroup = new this.Kinetic.Group();
    var minus = new this.Kinetic.Circle({
      x: this.width / 2 + 20,
      y: this.offsetTop / 2,
      fill: "#eee",
      radius: 10,
      strokeWidth: 1,
    });
    var rect1 = new this.Kinetic.Rect({
      x: this.width / 2 + 20 - 6,
      y: this.offsetTop / 2 - 2,
      fill: "black",
      height: 4,
      width: 12,
    });

    minusGroup.add(minus);
    minusGroup.add(rect1);
    minusGroup.on("mouseover", function () {
      minus.setFill("black");
      rect1.setFill("white");
      _this.uberLayer.draw();
    });

    minusGroup.on("mouseout", function () {
      minus.setFill("#eee");
      rect1.setFill("black");
      _this.stop_zoom();
      _this.uberLayer.draw();
    });

    minusGroup.on("click", function () {
      _this.update_zoom(-1);
      _this.uberLayer.draw();
    });

    minusGroup.on("mousedown", function () {
      minus.setFill("#222");
      rect1.setFill("yellow");
      _this.start_zoom(-1);
      _this.uberLayer.draw();
    });

    minusGroup.on("mouseup", function () {
      minus.setFill("black");
      rect1.setFill("white");
      _this.stop_zoom();
    });

    var plusGroup = new this.Kinetic.Group();
    var plus = new this.Kinetic.Circle({
      x: this.width / 2 + 45,
      y: this.offsetTop / 2,
      fill: "#eee",
      radius: 10,
      strokeWidth: 1,
    });
    var rect2 = new this.Kinetic.Rect({
      x: this.width / 2 + 45 - 7,
      y: this.offsetTop / 2 - 2,
      fill: "black",
      height: 4,
      width: 14,
    });
    var rect3 = new this.Kinetic.Rect({
      x: this.width / 2 + 45 - 2,
      y: this.offsetTop / 2 - 7,
      fill: "black",
      height: 14,
      width: 4,
    });

    plusGroup.add(plus);
    plusGroup.add(rect2);
    plusGroup.add(rect3);
    plusGroup.on("mouseover", function () {
      plus.setFill("black");
      rect2.setFill("white");
      rect3.setFill("white");
      _this.uberLayer.draw();
    });

    plusGroup.on("mouseout", function () {
      plus.setFill("#eee");
      rect2.setFill("black");
      rect3.setFill("black");
      _this.stop_zoom();
      _this.uberLayer.draw();
    });

    plusGroup.on("click", function () {
      _this.update_zoom(1);
      _this.uberLayer.draw();
    });

    plusGroup.on("mousedown", function () {
      plus.setFill("#222");
      rect2.setFill("yellow");
      rect3.setFill("yellow");
      _this.start_zoom(1);
      _this.uberLayer.draw();
    });

    plusGroup.on("mouseup", function () {
      plus.setFill("black");
      rect2.setFill("white");
      rect3.setFill("white");
      _this.stop_zoom();
    });

    this.uberLayer.add(minusGroup);
    this.uberLayer.add(plusGroup);
  },

  done: function (background_crop) {
    var ret = this.getCropInformation(
      this.image,
      {
        x: this.bgImage.getX(),
        y: this.bgImage.getY(),
        width: this.bgImage.getWidth(),
        height: this.bgImage.getHeight(),
      },
      background_crop
    );

    ret.bg_r = this.bg_color.r;
    ret.bg_g = this.bg_color.g;
    ret.bg_b = this.bg_color.b;
    this.is_done = true;

    return ret;
  },

  add_listener: function (evt, f) {
    if (typeof this.event_listeners[evt] == "undefined") {
      this.event_listeners[evt] = [];
    }

    this.event_listeners[evt].push(f);
  },

  remove_listener: function (evt, f) {
    if (typeof this.event_listeners[evt] == "undefined") {
      this.event_listeners[evt] = [];
    }

    var tmp = [];

    for (var k = 0; k < this.event_listeners[evt].length; k++) {
      if (this.event_listeners[evt][k] != f) {
        tmp.push(this.event_listeners[evt][k]);
      }
    }

    this.event_listeners[evt] = tmp;
  },

  post_event: function (evt, data) {
    if (typeof this.event_listeners[evt] == "undefined") {
      this.event_listeners[evt] = [];
    }

    for (var k = 0; k < this.event_listeners[evt].length; k++) {
      this.event_listeners[evt][k].call(this, data);
    }
  },
});

var MaskPlacement = function (container) {
  this._super(undefined, container);
  this.frame = null;
}.extend(CanvasWidget, {
  load_frames: function (imageSrc, imageMaskSrc, bgMaskSrc) {
    var _this = this;

    this.getOrCreateStage();
    var frameImageObj = new Image(),
      imageMaskObj = new Image(),
      bgMaskObj = new Image(),
      infoTxt = this.information(gettext("Loading image...")),
      info2;

    imageMaskObj.onload = function () {
      if (bgMaskSrc) {
        bgMaskObj.onload = function () {
          _this.maskLoaded(imageMaskObj, bgMaskObj);
          info2.dispose();
        };

        bgMaskObj.src = bgMaskSrc;
      } else {
        _this.maskLoaded(imageMaskObj);
        info2.dispose();
      }
    };

    frameImageObj.onload = function () {
      _this.frameLoaded(frameImageObj);
      infoTxt.dispose();
      imageMaskObj.src = imageMaskSrc;
      info2 = _this.information(gettext("Loading frames..."));
    };

    frameImageObj.src = imageSrc;
  },

  frameLoaded: function (frameImageObj) {
    var frameLayer = new this.Kinetic.Layer(),
      frameImage = this.create_image_in_box(frameImageObj, this.box, {});

    frameLayer.add(frameImage);
    this.stage.add(frameLayer);
  },

  maskLoaded: function (imageMaskObj, bgMaskObj) {
    var backgroundLayer = new this.Kinetic.Layer(),
      maskLayer = new this.Kinetic.Layer(),
      mask = this.create_image_in_box(imageMaskObj, this.box, {}),
      imageWidth = imageMaskObj.width,
      imageHeight = imageMaskObj.height;
    var buffer = document.createElement("canvas");

    buffer.width = imageWidth;
    buffer.height = imageHeight;
    var ctx = buffer.getContext("2d");

    ctx.drawImage(imageMaskObj, 0, 0, imageWidth, imageHeight);
    var maskData = ctx.getImageData(0, 0, imageWidth, imageHeight).data,
      bufferToMaskRatio = mask.getWidth() / imageWidth;
    var _frames = [],
      currentFrame = null,
      _bgFrame = null,
      pixel = 0;

    function inFrame(x, y) {
      for (var v in _frames) {
        if (
          _frames[v].start.x <= x &&
          x <= _frames[v].end.x &&
          _frames[v].start.y <= y &&
          y <= _frames[v].end.y
        ) {
          return _frames[v];
        }
      }

      return false;
    }

    var MASK = 0xff,
      MASK_BG = 0x80;

    for (y = 0; y < imageHeight; y++) {
      for (x = 0; x < imageWidth; x++) {
        pixel = (y * imageWidth + x) * 4;

        if (maskData[pixel] == MASK) {
          var f = inFrame(x, y);

          if (!f) {
            var x2 = x,
              y2 = y;

            while (maskData[4 * (y2 * imageWidth + x2)] == MASK) {
              x2 += 1;
            }

            x2 -= 1;

            while (maskData[4 * (y2 * imageWidth + x2)] == MASK) {
              y2 += 1;
            }

            y2 -= 1;
            _frames.push({
              start: { x: x, y: y },
              end: { x: x2, y: y2 },
            });
            x = x2;
          } else {
            x = f.end.x;
          }
        } else if (maskData[pixel] == MASK_BG && !_bgFrame) {
          var x2 = x,
            y2 = y;

          while (maskData[4 * (y2 * imageWidth + x2)] == MASK_BG) {
            x2 += 1;
          }

          x2 -= 1;

          while (maskData[4 * (y2 * imageWidth + x2)] == MASK_BG) {
            y2 += 1;
          }

          y2 -= 1;
          _bgFrame = {
            start: { x: x, y: y },
            end: { x: x2, y: y2 },
          };
        }
      }
    }

    this.stage.add(backgroundLayer);
    this.stage.add(maskLayer);
    this.frames = [];

    if (_bgFrame) {
      _bgFrame.start.x = _bgFrame.start.x * bufferToMaskRatio + mask.getX();
      _bgFrame.start.y = _bgFrame.start.y * bufferToMaskRatio + mask.getY();
      _bgFrame.end.x = _bgFrame.end.x * bufferToMaskRatio + mask.getX();
      _bgFrame.end.y = _bgFrame.end.y * bufferToMaskRatio + mask.getY();
      var f = new MaskPlacement.Frame(
        "bg",
        _bgFrame.start.x,
        _bgFrame.start.y,
        _bgFrame.end.x - _bgFrame.start.x,
        _bgFrame.end.y - _bgFrame.start.y,
        this
      );

      if (bgMaskObj) {
        f.setMask(bgMaskObj);
      }

      f.text = "";
      f.addToLayer(maskLayer, backgroundLayer);
      this.frames.push(f);
      this.bgFrame = f;
    }

    for (v in _frames) {
      // Put back to correct ratio and placement
      var _frame = _frames[v];

      _frame.start.x = _frame.start.x * bufferToMaskRatio + mask.getX();
      _frame.start.y = _frame.start.y * bufferToMaskRatio + mask.getY();
      _frame.end.x = _frame.end.x * bufferToMaskRatio + mask.getX();
      _frame.end.y = _frame.end.y * bufferToMaskRatio + mask.getY();
      var f = new MaskPlacement.Frame(
        parseInt(v) + 1,
        _frame.start.x,
        _frame.start.y,
        _frame.end.x - _frame.start.x,
        _frame.end.y - _frame.start.y,
        this
      );

      f.addToLayer(maskLayer, backgroundLayer);
      this.frames.push(f);
    }

    backgroundLayer.moveToBottom();
    maskLayer.moveToTop();
    this.backgroundLayer = backgroundLayer;
    this.canvasToImgRatio = bufferToMaskRatio;
    this.stage.draw();
  },

  askImage: function (callback) {},

  imageSelectionDone: function () {},

  notifyActiveFrame: function (frame) {
    for (f in this.frames) {
      if (this.frames[f] != frame && this.frames[f].active) {
        this.frames[f].setActive(false);

        if (this.frames[f].hasImage()) {
          this.paramOK();
        }
      }
    }

    this.organizeLayers(frame);
  },

  organizeLayers: function (frame) {
    if (this.bgFrame && frame != this.bgFrame) {
      this.backgroundLayer.moveToBottom();
      this.bgFrame.updatePosition();
    }
  },

  notifyFrameOK: function (frame) {
    this.imageSelectionDone();
    this.organizeLayers();
    this.paramOK();
  },

  paramOK: function () {},

  done: function (background_crop) {
    var ret = {};

    for (v in this.frames) {
      var frame = this.frames[v];

      ret[frame.number] = this.getCropInformation(
        frame.getUncroppedImage(),
        frame
      );

      // Add box dimensions information
      ret[frame.number].size_x = parseInt(frame.width / this.canvasToImgRatio);
      ret[frame.number].size_y = parseInt(frame.height / this.canvasToImgRatio);
      ret[frame.number].id = frame.img.id;
    }

    return ret;
  },
});

MaskPlacement.Frame = function (i, x, y, w, h, parent) {
  this.x = x;
  this.y = y;
  this.width = w;
  this.height = h;
  this.number = i;
  this.parent = parent;
  this.active = false;
  this.center = { x: this.x + this.width / 2, y: this.y + this.height / 2 };
  this.text = "?";
};

MaskPlacement.Frame.prototype = {
  setMask: function (imageMaskObj) {
    this.imageMask = imageMaskObj;
  },

  addToLayer: function (maskLayer, backgroundLayer) {
    var _this = this;
    /** Background layer **/
    this.bgGroup = new this.Kinetic.Group();
    this.bgGroup.colors = { font: "black", bg: "#ccc" };
    var bgRect = new this.Kinetic.Rect({
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height,
        fill: this.bgGroup.colors.bg,
        name: "rect",
      }),
      bgText = new this.Kinetic.Text({
        x: this.x,
        y: this.y + this.height / 3,
        width: this.width,
        fontFamily: "sans-serif",
        text: this.text,
        fontSize: this.height / 3,
        fill: this.bgGroup.colors.font,
        align: "center",
        fontStyle: "bold",
        name: "label",
      });

    this.bgGroup.add(bgRect);
    this.bgGroup.add(bgText);
    backgroundLayer.add(this.bgGroup);
    this.backgroundLayer = backgroundLayer;

    /** Mask layer: add transparent selection rect **/
    var maskRect = new this.Kinetic.Rect({
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height,
      name: "rect",
      /*StrokeWidth: 2,
			stroke: 'black', */
      opacity: 0,
      fill: "white",
    });

    maskLayer.add(maskRect);
    maskRect.on("mouseover", function () {
      if (!_this.hasImage()) {
        bgText.setTextFill("#aaa");
        bgRect.setFill("#333");
        backgroundLayer.draw();
      } else {
        _this.img.setOpacity(0.5);
        _this.img.getLayer().draw();
      }

      _this.parent.setPointer(true);
    });

    maskRect.on("mouseout", function () {
      if (!_this.hasImage()) {
        if (!_this.active) {
          bgText.setTextFill(_this.bgGroup.colors.font);
          bgRect.setFill(_this.bgGroup.colors.bg);
          backgroundLayer.draw();
        }
      } else {
        _this.img.setOpacity(1);
        _this.img.getLayer().draw();
      }

      _this.parent.setPointer(false);
      backgroundLayer.draw();
    });

    maskRect.on("click", function () {
      bgRect.setFill("#c00");
      _this.setActive(true);
      _this.parent.notifyActiveFrame(_this);
      _this.askImage(function (src) {
        _this.selectImage(src);
      });

      backgroundLayer.getStage().draw();
    });

    this.maskRect = maskRect;

    /** Edition layer **/
    this.editionLayer = new this.Kinetic.Layer({
      visible: false,
    });
    var blank_rect = new this.Kinetic.Rect({
      name: "blankrect",
      fill: "white",
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height,
    });

    this.img = new this.Kinetic.Image({
      name: "image",
      visible: false,
      draggable: true,
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height,
    });
    this.img.on("mouseover", function () {
      _this.parent.setPointer(true, { cursor: "move" });
    });

    this.img.on("mouseout", function () {
      _this.parent.setPointer(false);
    });

    this.editionGroup = new this.Kinetic.Group({
      visible: false,
    });

    // Use a line instead of a rect let the inside clickable
    this.scaleRect = new this.Kinetic.Line({
      points: [
        this.x,
        this.y,
        this.x + this.width,
        this.y,
        this.x + this.width,
        this.y + this.height,
        this.x,
        this.y + this.height,
        this.x,
        this.y,
      ],
      stroke: "black",
      strokeWidth: 2,
      name: "scalerect",
    });
    this.editionGroup.add(this.scaleRect);
    this.addScaleAnchor(this.editionGroup, this.x, this.y, "topleft");
    this.addScaleAnchor(
      this.editionGroup,
      this.x + this.width,
      this.y + this.height,
      "bottomright"
    );
    this.addActionAnchor(this.editionGroup, this.x + this.width, this.y, "ok");
    this.addActionAnchor(
      this.editionGroup,
      this.x,
      this.y + this.height,
      "delete"
    );

    if (this.imageMask) {
      this.editionLayer.afterDraw(function () {
        var ctx = _this.editionLayer.getContext();

        ctx.globalCompositeOperation = "xor";
        ctx.drawImage(
          _this.imageMask,
          _this.x,
          _this.y,
          _this.width,
          _this.height
        );
      });
    }

    this.editionLayer.add(blank_rect);
    this.editionLayer.add(this.img);
    this.editionLayer.add(this.editionGroup);

    maskLayer.getStage().add(this.editionLayer);
    this.editionLayer.moveToBottom();
  },

  selectImage: function (image) {
    if (!this.active) {
      return false;
    }

    var pic = new Image(),
      info = this.parent.information(gettext("Loading image...")),
      _this = this;

    pic.onload = function () {
      _this.importImage(pic);
      info.dispose();
    };

    pic.id = image.id;
    pic.src = image.src;
  },

  hasImage: function () {
    return this.img.id;
  },

  importImage: function (imgObj) {
    this.parent.create_image_in_box(imgObj, this, {
      fit_within: false,
      image: this.img,
    });
    this.img.id = imgObj.id;
    this.img.orig_pos = null;
    this.img.setVisible(true);
    this.img.setOpacity(0.6);
    this.setActive(true);
    this.editionLayer.draw();
  },

  getUncroppedImage: function () {
    if (!this.active && this.img.orig_pos) {
      return {
        x: this.img.orig_pos.x,
        y: this.img.orig_pos.y,
        width: this.img.orig_size.width,
        height: this.img.orig_size.height,
      };
    }

    return this.img;
  },

  setActive: function (active) {
    if (active) {
      this.active = true;

      if (this.hasImage()) {
        if (this.img.orig_pos) {
          this.img.setPosition(this.img.orig_pos);
          this.img.setSize(this.img.orig_size);
          this.img.setCrop(null);
        }

        this.editionLayer.setVisible(true);
        this.editionLayer.moveToTop();
        this.editionGroup.setVisible(true);
        this.bgGroup.setVisible(false);
        this.img.transitionTo({ opacity: 0.6, duration: 2 });
        this.bgGroup.getLayer().draw();
      } else {
        this.editionLayer.moveToBottom();
        this.editionLayer.setVisible(false);
        this.bgGroup.setVisible(true);
        this.bgGroup.getLayer().moveToBottom();
        this.bgGroup.getLayer().draw();
      }

      this.maskRect.setVisible(false);
    } else {
      this.active = false;
      this.editionGroup.setVisible(false);
      this.bgGroup.get(".label")[0].setTextFill(this.bgGroup.colors.font);
      this.bgGroup.get(".rect")[0].setFill(this.bgGroup.colors.bg);

      if (this.hasImage()) {
        // Crop image, otherwise it may appear on other frames...
        // save image attribtues
        this.img.orig_pos = this.img.getPosition();
        this.img.orig_size = this.img.getSize();

        var new_x = Math.max(this.x, this.img.getX()),
          new_y = Math.max(this.y, this.img.getY()),
          new_width = Math.max(
            0,
            Math.min(
              this.width,
              this.img.getWidth(),
              this.img.getX() + this.img.getWidth() - this.x,
              this.x + this.width - this.img.getX()
            )
          ),
          new_height = Math.max(
            0,
            Math.min(
              this.height,
              this.img.getHeight(),
              this.img.getY() + this.img.getHeight() - this.y,
              this.y + this.height - this.img.getY()
            )
          );

        // Crop computation
        var crop_x = Math.min(
            this.img.attrs.image.width,
            Math.max(
              0,
              (this.img.attrs.image.width * (new_x - this.img.getX())) /
                this.img.getWidth()
            )
          ),
          crop_y = Math.min(
            this.img.attrs.image.height,
            Math.max(
              0,
              (this.img.attrs.image.height * (new_y - this.img.getY())) /
                this.img.getHeight()
            )
          ),
          crop_width = Math.min(
            this.img.attrs.image.width,
            (this.img.attrs.image.width * new_width) / this.img.getWidth()
          ),
          crop_height = Math.min(
            this.img.attrs.image.height,
            (this.img.attrs.image.height * new_height) / this.img.getHeight()
          );

        this.img.setSize({ width: new_width, height: new_height });
        this.img.setPosition({ x: new_x, y: new_y });
        this.img.setCrop({
          x: crop_x,
          y: crop_y,
          width: crop_width,
          height: crop_height,
        });
        this.img.transitionTo({ opacity: 1, duration: 2 });
        this.img.getLayer().draw();
        this.editionLayer.moveToBottom();
        this.editionLayer.moveUp();
      }

      this.maskRect.setVisible(true);
    }

    this.maskRect.getLayer().getStage().draw();
  },

  updatePosition: function () {
    if (this.imageMask) {
      this.editionLayer.moveToTop();
      this.editionLayer.moveDown();
      this.editionLayer.moveDown();
    } else {
      this.editionLayer.moveToBottom();
    }
  },

  addScaleAnchor: function (group, x, y, name) {
    var _this = this,
      orig_x = x,
      orig_y = y,
      anchor_color = "#0000ff";

    var anchor = new this.Kinetic.Circle({
      x: x,
      y: y,
      stroke: "#000",
      fill: anchor_color,
      strokeWidth: 2,
      radius: 5,
      draggable: true,
      name: name,
      dragBoundFunc: function (pos) {
        var new_x = pos.x;

        switch (name) {
          case "topleft":
            if (pos.x >= _this.center.x - 2) {
              new_x = _this.center.x - 3;
            }

            break;
          case "bottomright":
            if (pos.x <= _this.center.x + 2) {
              new_x = _this.center.x + 3;
            }

            break;
        }

        return {
          x: new_x,
          y: orig_y + ((new_x - orig_x) * _this.height) / _this.width,
        };
      },
    });

    group.add(anchor);
    anchor.on("mouseover", function () {
      anchor.setFill("#dddd00");
      anchor.getLayer().draw();
      _this.parent.setPointer(true, {
        cursor: name == "bottomright" ? "se-resize" : "nw-resize",
      });
    });

    anchor.on("mouseout", function () {
      anchor.setFill(anchor_color);
      anchor.getLayer().draw();
      _this.parent.setPointer(false);
    });

    anchor.on("dragstart", function () {
      _this.img.orig_width = _this.img.getWidth();
      _this.img.orig_pos = [_this.img.getX(), _this.img.getY()];
      _this.img.center = [
        _this.img.getX() + _this.img.getWidth() / 2,
        _this.img.getY() + _this.img.getHeight() / 2,
      ];
      anchor.setFill("#00ff00");
    });

    anchor.on("dragmove", function () {
      var topleft = group.get(".topleft")[0],
        bottomright = group.get(".bottomright")[0];

      anchor.zoom =
        (_this.center.x - anchor.attrs.x) / (_this.center.x - orig_x);
      _this.scaleRect.setPoints([
        topleft.attrs.x,
        topleft.attrs.y,
        bottomright.attrs.x,
        topleft.attrs.y,
        bottomright.attrs.x,
        bottomright.attrs.y,
        topleft.attrs.x,
        bottomright.attrs.y,
        topleft.attrs.x,
        topleft.attrs.y,
      ]);
      var new_w = _this.img.orig_width * anchor.zoom,
        new_h = new_w / _this.img.aspect_ratio,
        new_x =
          _this.center.x -
          (_this.center.x - _this.img.orig_pos[0]) * anchor.zoom;

      new_y =
        _this.center.y - (_this.center.y - _this.img.orig_pos[1]) * anchor.zoom;
      _this.img.setPosition(new_x, new_y);
      _this.img.setSize(new_w, new_h);
    });

    anchor.on("dragend", function (evt) {
      anchor.setPosition(orig_x, orig_y);
      _this.scaleRect.setPoints([
        _this.x,
        _this.y,
        _this.x + _this.width,
        _this.y,
        _this.x + _this.width,
        _this.y + _this.height,
        _this.x,
        _this.y + _this.height,
        _this.x,
        _this.y,
      ]);
      _this.scaleRect.getLayer().draw();
      anchor.setFill("#ff0000");
      anchor.getLayer().draw();
    });

    return anchor;
  },

  addActionAnchor: function (group, x, y, name) {
    var _this = this,
      orig_x = x,
      orig_y = y;
    var radius = 14;
    var anchor = new this.Kinetic.Circle({
        x: x,
        y: y,
        stroke: "#000",
        fill: name == "ok" ? "#00ff00" : "#ff0000",
        strokeWidth: 2,
        radius: radius,
        draggable: false,
        name: name,
      }),
      text = new this.Kinetic.Text({
        x: x - radius,
        y: y - radius + 10,
        width: 2 * radius,
        fontSize: 10,
        align: "center",
        fontFamily: "sans-serif",
        text: name == "ok" ? "OK" : "X",
        fill: "white",
      });
    var anchorGoup = new this.Kinetic.Group({ name: name });

    anchorGoup.add(anchor);
    anchorGoup.add(text);
    group.add(anchorGoup);
    anchorGoup.on("mouseover", function () {
      text.orig_fill = text.getTextFill();
      text.setTextFill("black");
      anchor.getLayer().draw();
      _this.parent.setPointer(true, {
        cursor: name == "ok" ? "pointer" : "not-allowed",
      });
    });

    anchorGoup.on("mouseout", function () {
      text.setTextFill(text.orig_fill);
      anchor.getLayer().draw();
      _this.parent.setPointer(false);
    });

    anchorGoup.on("click", function (evt) {
      if (name == "ok") {
        _this.setActive(false);
        _this.parent.notifyFrameOK(_this);
      } else {
        _this.img.setVisible(false);
        _this.img.id = null;
        _this.setActive(true);
        _this.parent.organizeLayers(_this);
        _this.parent.paramOK();
      }
    });

    return anchor;
  },

  askImage: function (callback) {
    this.parent.askImage(callback);
  },
};

function PaintCanvas() {
  // see http://jsfiddle.net/95tft/283/ and http://www.mrdoob.com/projects/harmony/
  this.height = window.innerHeight * 0.75;
  this.width = window.innerWidth * 0.75;
  this.brush_pressure = 10;
  this.mouseX = 0;
  this.mouseY = 0;
  this.appendTo = document.body;
}

PaintCanvas.BRUSHES = {
  ribbon: null,
  profile: function (ctx) {
    var context = ctx,
      interval = null,
      width = context.canvas.width,
      height = context.canvas.height,
      mouse_pos = { x: width / 2, y: height / 2 },
      brush_size = 2,
      brush_pressure = 12,
      color = [1, 0, 0],
      bg_color = [250, 250, 250],
      update = null,
      aspect_ratio = 0.5,
      old_mouseY = -1,
      start_y = 0,
      inner_width = 0,
      start_x = 0,
      inner_height = 0,
      plots = new Array(),
      nb_plots = parseInt(height / 1.5);
    var painter = {
      dx: mouse_pos.x,
      dy: mouse_pos.y,
      ax: 0,
      ay: 0,
      div: 0.1,
      ease: Math.random() * 0.1 + 0.5,
    };

    // Context.globalCompositeOperation = 'source-over';

    var update = function () {
      if (mouse_pos.y < old_mouseY) {
        return;
      }

      old_mouseY = mouse_pos.y;
      context.lineWidth = brush_size;
      context.strokeStyle =
        "rgba(" +
        color[0] +
        ", " +
        color[1] +
        ", " +
        color[2] +
        ", " +
        0.05 * brush_pressure +
        ")";
      context.strokeStyle =
        "rgb(" + color[0] + ", " + color[1] + ", " + color[2] + ")";
      context.beginPath();
      context.moveTo(painter.dx, painter.dy);
      plots.push([painter.dx, painter.dy]);
      painter.dx -= painter.ax =
        (painter.ax + (painter.dx - mouse_pos.x) * painter.div) * painter.ease;
      painter.dy -= painter.ay =
        (painter.ay + (painter.dy - mouse_pos.y) * painter.div) * painter.ease;
      context.lineTo(painter.dx, painter.dy);
      context.stroke();
    };

    var clear = function () {
      plots = new Array();
      context.clearRect(0, 0, width, height);
      context.beginPath();
      context.rect(0, 0, width, height);
      context.fillStyle = "rgba(40,40,40, 0.4)";
      context.fill();
      start_y = height / 10.0;
      inner_height = parseInt(height - 2 * start_y);
      inner_width = parseInt(inner_height * aspect_ratio);
      start_x = parseInt((width - inner_width) / 2);
      start_y = parseInt(start_y);
      context.clearRect(start_x, start_y, inner_width, inner_height);
      old_mouseY = -1;
    };

    clear();

    return {
      destroy: function () {},

      strokeStart: function (mouseX, mouseY) {
        clear();
        interval = setInterval(update, 1000 / 60);
        mouse_pos.x = mouseX;
        mouse_pos.y = mouseY;
        painter.dx = mouseX;
        painter.dy = mouseY;
      },

      stroke: function (mouseX, mouseY) {
        mouse_pos.x = mouseX;
        mouse_pos.y = mouseY;
      },

      strokeEnd: function () {
        clearInterval(interval);
      },

      get_aspectratio: function () {
        return aspect_ratio;
      },

      get_plots: function () {
        var ret = new Array();
        var drawData = context.getImageData(
          start_x,
          start_y,
          inner_width,
          inner_height
        ).data;
        var x, y, pixel;
        var mask = color[0];

        for (var i = 0; i < nb_plots; i++) {
          y = parseInt((i * inner_height * 1.0) / nb_plots);

          // Scan for a non white pixel at this line
          for (x = 0; x < inner_width; x++) {
            pixel = (y * inner_width + x) * 4;

            if (drawData[pixel] == mask) {
              // Push normalized data
              var val = (x * 1.0) / inner_width;

              if (val < 0) {
                val = 0.0;
              }

              if (val > 1) {
                val = 1.0;
              }

              ret.push(val);
              break;
            }
          }

          if (x == inner_width) {
            // No hit...
            if (i != 0) {
              ret.push(ret[i - 1]);
            } else {
              ret.push(0.5);
            }
          }
        }

        return ret;
      },
    };
  },
};
PaintCanvas.prototype = {
  init: function () {
    var USER_AGENT = navigator.userAgent.toLowerCase();
    var container = document.createElement("div");

    if (USER_AGENT.search("android") > -1 || USER_AGENT.search("iphone") > -1) {
      this.brush_size = 2;
    }

    this.appendTo.appendChild(container);
    this.canvas = document.createElement("canvas");
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.canvas.style.cursor = "crosshair";
    container.appendChild(this.canvas);
    this.context = this.canvas.getContext("2d");

    // This.brush = eval("new " + PaintCanvas.BRUSHES[0] + "(this.context)");
    this.brush = new PaintCanvas.BRUSHES.profile(this.context);
    this.listeners = {
      // Mouseout: this.onDocumentMouseOut.bind(this), // continue to draw if we go out
      mousedown: this.onCanvasMouseDown.bind(this),
      mousemove: this.onCanvasMouseMove.bind(this),
      mouseup: this.onCanvasMouseUp.bind(this),
      touchstart: this.onCanvasTouchStart.bind(this),
      touchend: this.onCanvasTouchEnd.bind(this),
    };
    document.addEventListener("mouseout", this.listeners.mouseout, false);
    this.canvas.addEventListener("mousedown", this.listeners.mousedown, false);
    this.canvas.addEventListener(
      "touchstart",
      this.listeners.touchstart,
      false
    );
  },

  getMousePos: function (evt) {
    var rect = this.canvas.getBoundingClientRect();

    return {
      x: evt.clientX - rect.left,
      y: evt.clientY - rect.top,
    };
  },

  // DOCUMENT
  onDocumentMouseOut: function (event) {
    this.onCanvasMouseUp();
  },

  // CANVAS
  onCanvasMouseDown: function (event) {
    var position = this.getMousePos(event);

    this.brush.strokeStart(position.x, position.y);
    window.addEventListener("mousemove", this.listeners.mousemove, false);
    window.addEventListener("mouseup", this.listeners.mouseup, false);
  },

  onCanvasMouseMove: function (event) {
    var position = this.getMousePos(event);

    this.brush.stroke(position.x, position.y);
  },

  onCanvasMouseUp: function () {
    this.brush.strokeEnd();
    window.removeEventListener("mousemove", this.listeners.mousemove, false);
    window.removeEventListener("mouseup", this.listeners.mouseup, false);
  },

  onCanvasTouchStart: function (event) {
    if (event.touches.length == 1) {
      event.preventDefault();
      brush.strokeStart(event.touches[0].pageX, event.touches[0].pageY);
      window.addEventListener("touchmove", this.listeners.mousemove, false);
      window.addEventListener("touchend", this.listeners.touchend, false);
    }
  },

  onCanvasTouchMove: function (event) {
    if (event.touches.length == 1) {
      event.preventDefault();
      this.brush.stroke(event.touches[0].pageX, event.touches[0].pageY);
    }
  },

  onCanvasTouchEnd: function (event) {
    if (event.touches.length == 0) {
      event.preventDefault();
      this.brush.strokeEnd();
      window.removeEventListener("touchmove", this.listeners.mousemove, false);
      window.removeEventListener("touchend", this.listeners.touchend, false);
    }
  },
};
